// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import ApiUrl from "../Environment/ApiUrl";
// import { useToast } from "../Toast/ToastContext";

// function UpdatePurchase({ toggleSidebar }) {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const toast = useToast();
//   const [loading, setLoading] = useState(false);
//   const [showModal, setShowModal] = useState(false);
//   const [productTypes, setProductTypes] = useState([]);
//   const [suppliers, setSuppliers] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedSupplier, setSelectedSupplier] = useState(null);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const [editingItemId, setEditingItemId] = useState(null);

//   // Form data state
//   const [updateData, setUpdateData] = useState({
//     purchase_id: "",
//     purchase_date: new Date().toISOString().split("T")[0],
//     supplier_id: "",
//     return_type: "",
//     paid: "",
//     pure: "",
//     opening: "0.000",
//     current: "0.000",
//     close: "0.000",
//     total_pure: "0.000",
//     enter_amount: "",
//     items: [],
//     supplier_details: {
//       supplier_id: "",
//       name: null,
//       mobile: null,
//       address: null,
//     },
//   });

//   // New item state
//   const [newItem, setNewItem] = useState({
//     item: "",
//     category: "",
//     other_name: "",
//     type: "",
//     quantity: "",
//     weight: "",
//     purity: "",
//     pure: "0.000",
//     total_amount: "0.000",
//   });

//   // Calculate pure and total_amount for new item
//   useEffect(() => {
//     let pure = "0.000";
//     let total_amount = "0.000";

//     if (newItem.weight && newItem.purity && newItem.quantity) {
//       const weight = parseFloat(newItem.weight);
//       const purity = parseFloat(newItem.purity);
//       const quantity = parseFloat(newItem.quantity);

//       if (!isNaN(weight) && !isNaN(purity) && !isNaN(quantity)) {
//         if (purity > 100) {
//           toast.error("Purity cannot exceed 100%", 3000, "topRight");
//           setNewItem((prev) => ({ ...prev, purity: "" }));
//           return;
//         }
//         const singlePure = (weight * purity) / 100;
//         pure = (quantity * singlePure).toFixed(3);
//         total_amount = (quantity * weight * (purity / 100)).toFixed(3);
//       }
//     }

//     setNewItem((prev) => ({ ...prev, pure, total_amount }));
//   }, [newItem.weight, newItem.purity, newItem.quantity, toast]);

//   // Calculate total_pure from items
//   useEffect(() => {
//     const totalPure = updateData.items
//       .reduce((sum, item) => sum + parseFloat(item.pure || 0), 0)
//       .toFixed(3);
//     setUpdateData((prev) => ({ ...prev, total_pure: totalPure }));
//   }, [updateData.items]);

//   // Calculate current (opening + total_pure for Pure, opening + enter_amount for Amount)
//   useEffect(() => {
//     let current = "0.000";
//     const opening = parseFloat(updateData.opening) || 0;

//     if (updateData.return_type === "Pure") {
//       const totalPure = parseFloat(updateData.total_pure) || 0;
//       current = (opening + totalPure).toFixed(3);
//     } else if (updateData.return_type === "Amount") {
//       const enterAmount = parseFloat(updateData.enter_amount) || 0;
//       current = (opening + enterAmount).toFixed(3);
//     } else {
//       current = opening.toFixed(3);
//     }

//     setUpdateData((prev) => ({ ...prev, current }));
//   }, [updateData.total_pure, updateData.opening, updateData.enter_amount, updateData.return_type]);

//   // Calculate closing (total_pure - pure for Pure, opening + enter_amount - paid for Amount)
//   useEffect(() => {
//     let close = "0.000";

//     if (updateData.return_type === "Pure") {
//       const totalPure = parseFloat(updateData.total_pure) || 0;
//       const pure = parseFloat(updateData.pure) || 0;
//       if (pure > totalPure) {
//         toast.error("Pure value cannot exceed Total Pure", 3000, "topRight");
//         setUpdateData((prev) => ({ ...prev, pure: "" }));
//         close = totalPure.toFixed(3);
//       } else {
//         close = (totalPure - pure).toFixed(3);
//       }
//     } else if (updateData.return_type === "Amount") {
//       const opening = parseFloat(updateData.opening) || 0;
//       const enterAmount = parseFloat(updateData.enter_amount) || 0;
//       const paid = parseFloat(updateData.paid) || 0;
//       const current = parseFloat(updateData.current) || 0;

//       if (paid > current) {
//         toast.error("Paid amount cannot exceed Enter Amount", 3000, "topRight");
//         setUpdateData((prev) => ({ ...prev, paid: "" }));
//         close = (opening + enterAmount).toFixed(3);
//       } else {
//         close = (opening + enterAmount - paid).toFixed(3);
//       }
//     }

//     setUpdateData((prev) => ({ ...prev, close }));
//   }, [updateData.total_pure, updateData.pure, updateData.enter_amount, updateData.paid, updateData.return_type, updateData.opening, toast]);

//   // Reset type when item is "Bar"
//   useEffect(() => {
//     if (newItem.item === "Bar") {
//       setNewItem((prev) => ({ ...prev, type: "", purity: "100" }));
//     }
//   }, [newItem.item]);

//   // Fetch data on component mount
//   useEffect(() => {
//     if (toggleSidebar) toggleSidebar();
//     fetchProductTypes();
//     fetchSuppliers();
//     if (id) {
//       fetchPurchaseData();
//     }
//   }, [id]);

//   // Fetch purchase data
//   const fetchPurchaseData = async () => {
//     setLoading(true);
//     try {
//       const response = await axios.get(
//         `${ApiUrl}/Api/purchase_details.php?id=${id}`
//       );
//       const purchaseData = response.data.data[0];

//       if (purchaseData) {
//         setUpdateData({
//           purchase_id: purchaseData.purchase_id,
//           purchase_date: purchaseData.purchase_date,
//           supplier_id: purchaseData.supplier_id,
//           return_type: purchaseData.return_type,
//           paid: purchaseData.paid || "",
//           pure: purchaseData.pure || "",
//           opening: parseFloat(purchaseData.opening).toFixed(3) || "0.000",
//           current: parseFloat(purchaseData.current).toFixed(3) || "0.000",
//           close: parseFloat(purchaseData.close).toFixed(3) || "0.000",
//           total_pure: parseFloat(purchaseData.total_pure).toFixed(3) || "0.000",
//           enter_amount: purchaseData.enter_amount || "",
//           items: purchaseData.items.map((item, index) => ({
//             id: index + 1,
//             purchase_id: item.purchase_id,
//             item: item.item,
//             other_name: item.other_name || "",
//             category: item.category,
//             type: item.type || "",
//             quantity: parseFloat(item.quantity) || 0,
//             weight: parseFloat(item.weight) || 0,
//             purity: parseFloat(item.percentage) || 0,
//             pure: parseFloat(item.pure) || 0,
//             total_amount: parseFloat(item.total_amount) || 0,
//           })),
//           supplier_details: {
//             supplier_id: purchaseData.supplier.supplier_id,
//             name: purchaseData.supplier.name,
//             mobile: purchaseData.supplier.mobile,
//             address: purchaseData.supplier.address,
//           },
//         });
//         setSelectedSupplier(purchaseData.supplier);
//         setSearchTerm(
//           `${purchaseData.supplier.supplier_id} - ${purchaseData.supplier.name}`
//         );
//         await handleSelectSupplier(purchaseData.supplier, true);
//       }
//     } catch (error) {
//       console.error("Error fetching purchase data:", error);
//       toast.error("Failed to load purchase data", 3000, "topRight");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Fetch product types
//   const fetchProductTypes = async () => {
//     try {
//       const response = await axios.get(`${ApiUrl}/Api/product_type.php`);
//       setProductTypes(response.data?.data || []);
//     } catch (error) {
//       console.error("Error fetching product types:", error);
//       toast.error("Failed to fetch product types", 3000, "topRight");
//     }
//   };

//   // Fetch suppliers
//   const fetchSuppliers = async () => {
//     try {
//       const response = await axios.get(`${ApiUrl}/Api/supplier.php`);
//       setSuppliers(response.data?.data || []);
//     } catch (error) {
//       console.error("Error fetching suppliers:", error);
//       toast.error("Failed to fetch suppliers", 3000, "topRight");
//     }
//   };

//   // Handle supplier selection and fetch supplier-specific opening balance
//   const handleSelectSupplier = async (supplier, isLoad = false) => {
//     setSelectedSupplier(supplier);
//     setSearchTerm(`${supplier.supplier_id} - ${supplier.name}`);
//     setUpdateData((prev) => ({
//       ...prev,
//       supplier_id: supplier.supplier_id,
//       supplier_details: {
//         supplier_id: supplier.supplier_id,
//         name: supplier.name,
//         mobile: supplier.mobile,
//         address: supplier.address,
//       },
//     }));
//     setShowDropdown(false);

//     try {
//       const response = await axios.get(`${ApiUrl}/Api/purchase_details.php`);
//       const supplierPurchases = response.data.data.filter(
//         (purchase) => purchase.supplier_id === supplier.supplier_id && purchase.purchase_id !== updateData.purchase_id
//       );
//       const totalOpening = supplierPurchases
//         .reduce((sum, purchase) => sum + parseFloat(purchase.close || 0), 0)
//         .toFixed(3);
//       if (!isLoad) {
//         setUpdateData((prev) => ({
//           ...prev,
//           opening: totalOpening,
//         }));
//       }
//     } catch (error) {
//       console.error("Error fetching supplier purchases:", error);
//       toast.error("Failed to fetch supplier opening balance", 3000, "topRight");
//       setUpdateData((prev) => ({
//         ...prev,
//         opening: "0.000",
//       }));
//     }
//   };

//   const clearSupplier = () => {
//     setSelectedSupplier(null);
//     setSearchTerm("");
//     setUpdateData((prev) => ({
//       ...prev,
//       supplier_id: "",
//       supplier_details: {
//         supplier_id: "",
//         name: null,
//         mobile: null,
//         address: null,
//       },
//       opening: "0.000",
//     }));
//   };

//   // Handle adding a new item
//   const handleAddItem = () => {
//     if (!validateItem()) return;

//     const newItems = [
//       ...updateData.items,
//       {
//         id: updateData.items.length + 1,
//         purchase_id: updateData.purchase_id,
//         item: newItem.item,
//         other_name: newItem.other_name,
//         category: newItem.category,
//         type: newItem.type,
//         quantity: parseFloat(newItem.quantity) || 0,
//         weight: parseFloat(newItem.weight) || 0,
//         purity: parseFloat(newItem.purity) || 0,
//         pure: parseFloat(newItem.pure) || 0,
//         total_amount: parseFloat(newItem.total_amount) || 0,
//       },
//     ];

//     setUpdateData((prev) => ({ ...prev, items: newItems }));
//     resetNewItem();
//   };

//   // Validate new item
//   const validateItem = () => {
//     if (!newItem.item) {
//       toast.error("Please select an item", 3000, "topRight");
//       return false;
//     }
//     if (!newItem.category) {
//       toast.error("Please select a category", 3000, "topRight");
//       return false;
//     }
//     if (newItem.item !== "Bar" && !newItem.type) {
//       toast.error("Please select a type", 3000, "topRight");
//       return false;
//     }
//     if (!newItem.quantity || parseFloat(newItem.quantity) <= 0) {
//       toast.error("Please enter a valid quantity", 3000, "topRight");
//       return false;
//     }
//     if (!newItem.weight || parseFloat(newItem.weight) <= 0) {
//       toast.error("Please enter a valid weight", 3000, "topRight");
//       return false;
//     }
//     if (
//       !newItem.purity ||
//       parseFloat(newItem.purity) <= 0 ||
//       parseFloat(newItem.purity) > 100
//     ) {
//       toast.error("Please enter a valid purity (0-100%)", 3000, "topRight");
//       return false;
//     }
//     if (newItem.item === "Others" && !newItem.other_name) {
//       toast.error("Please enter a name for 'Others'", 3000, "topRight");
//       return false;
//     }
//     return true;
//   };

//   // Reset new item form
//   const resetNewItem = () => {
//     setNewItem({
//       item: "",
//       category: "",
//       other_name: "",
//       type: "",
//       quantity: "",
//       weight: "",
//       purity: "",
//       pure: "0.000",
//       total_amount: "0.000",
//     });
//     setEditingItemId(null);
//   };

//   // Handle removing an item
//   const handleRemoveItem = (itemId) => {
//     const updatedItems = updateData.items
//       .filter((item) => item.id !== itemId)
//       .map((item, index) => ({ ...item, id: index + 1 }));
//     setUpdateData((prev) => ({ ...prev, items: updatedItems }));
//   };

//   // Handle editing an item
//   const handleEditItem = (itemId) => {
//     const itemToEdit = updateData.items.find((item) => item.id === itemId);
//     if (itemToEdit) {
//       setNewItem({
//         item: itemToEdit.item,
//         category: itemToEdit.category,
//         other_name: itemToEdit.other_name,
//         type: itemToEdit.type,
//         quantity: itemToEdit.quantity.toString(),
//         weight: itemToEdit.weight.toString(),
//         purity: itemToEdit.purity.toString(),
//         pure: itemToEdit.pure.toFixed(3),
//         total_amount: itemToEdit.total_amount.toFixed(3),
//       });
//       setEditingItemId(itemId);
//     }
//   };

//   // Handle updating an item
//   const handleUpdateItem = () => {
//     if (!validateItem() || editingItemId === null) return;

//     const updatedItems = updateData.items.map((item) =>
//       item.id === editingItemId
//         ? {
//             ...item,
//             item: newItem.item,
//             purchase_id: updateData.purchase_id,
//             category: newItem.category,
//             other_name: newItem.other_name,
//             type: newItem.type,
//             quantity: parseFloat(newItem.quantity) || 0,
//             weight: parseFloat(newItem.weight) || 0,
//             purity: parseFloat(newItem.purity) || 0,
//             pure: parseFloat(newItem.pure) || 0,
//             total_amount: parseFloat(newItem.total_amount) || 0,
//           }
//         : item
//     );

//     setUpdateData((prev) => ({ ...prev, items: updatedItems }));
//     resetNewItem();
//   };

//   // Validate form before save or print
//   const validateForm = () => {
//     if (!updateData.purchase_id) {
//       toast.error("Purchase ID is required", 3000, "topRight");
//       return false;
//     }
//     if (!updateData.purchase_date) {
//       toast.error("Purchase date is required", 3000, "topRight");
//       return false;
//     }
//     if (!updateData.supplier_id) {
//       toast.error("Please select a supplier", 3000, "topRight");
//       return false;
//     }
//     if (updateData.items.length === 0) {
//       toast.error("Please add at least one item", 3000, "topRight");
//       return false;
//     }
//     if (
//       updateData.return_type === "Pure" &&
//       (!updateData.pure || parseFloat(updateData.pure) < 0)
//     ) {
//       toast.error("Please enter a valid pure value", 3000, "topRight");
//       return false;
//     }
//     if (
//       updateData.return_type === "Amount" &&
//       (!updateData.enter_amount || parseFloat(updateData.enter_amount) <= 0)
//     ) {
//       toast.error("Please enter a valid amount to pay", 3000, "topRight");
//       return false;
//     }
//     if (
//       updateData.return_type === "Amount" &&
//       (!updateData.paid || parseFloat(updateData.paid) < 0)
//     ) {
//       toast.error("Please enter a valid paid amount", 3000, "topRight");
//       return false;
//     }
//     if (
//       updateData.return_type === "Amount" &&
//       parseFloat(updateData.paid) > parseFloat(updateData.current)
//     ) {
//       toast.error("Paid amount cannot exceed Enter Amount", 3000, "topRight");
//       return false;
//     }
//     // Additional validation for closing balance
//     const expectedClose = parseFloat(updateData.opening) + parseFloat(updateData.enter_amount || 0) - parseFloat(updateData.paid || 0);
//     if (updateData.return_type === "Amount" && parseFloat(updateData.close) !== expectedClose) {
//       toast.error(`Invalid close value. Expected: ${expectedClose.toFixed(3)}, Received: ${parseFloat(updateData.close).toFixed(3)}`, 3000, "topRight");
//       return false;
//     }
//     return true;
//   };

//   // Prepare payload for API
//   const preparePayload = () => {
//     let payload = {
//       purchase_id: updateData.purchase_id,
//       purchase_date: updateData.purchase_date,
//       supplier_id: updateData.supplier_id,
//       return_type: updateData.return_type,
//       paid: parseFloat(updateData.paid) || 0,
//       pure: parseFloat(updateData.pure) || 0,
//       opening: parseFloat(updateData.opening) || 0,
//       current: parseFloat(updateData.current) || 0,
//       close: parseFloat(updateData.close) || 0,
//       total_pure: parseFloat(updateData.total_pure) || 0,
//       enter_amount: parseFloat(updateData.enter_amount) || 0,
//       items: updateData.items.map((item) => ({
//         category: item.category,
//         quantity: parseFloat(item.quantity) || 0,
//         item: item.item,
//         weight: parseFloat(item.weight) || 0,
//         type: item.type,
//         other_name: item.other_name || "",
//         percentage: parseFloat(item.purity) || 0,
//         pure: parseFloat(item.pure) || 0,
//         total_amount: parseFloat(item.total_amount) || 0,
//         purchase_id: updateData.purchase_id,
//       })),
//     };

//     if (updateData.return_type === "Pure") {
//       payload.paid = 0;
//       payload.enter_amount = 0;
//     } else if (updateData.return_type === "Amount") {
//       payload.pure = 0;
//     } else {
//       payload.pure = 0;
//       payload.paid = 0;
//       payload.enter_amount = 0;
//     }

//     return payload;
//   };

//   // Handle saving the updated purchase
//   const handleUpdate = async () => {
//     if (!validateForm()) return;

//     setLoading(true);
//     try {
//       const payload = preparePayload();
//       const response = await axios.put(
//         `${ApiUrl}/Api/purchase_details.php/${id}`,
//         payload
//       );

//       if (response.status === 200 || response.status === 201) {
//         toast.success("Purchase updated successfully!", 3000, "topRight");
//         navigate("/purchases");
//       } else {
//         toast.error(
//           response.data.message || "Failed to update purchase",
//           3000,
//           "topRight"
//         );
//       }
//     } catch (error) {
//       console.error("Error updating purchase:", error);
//       toast.error(
//         `Failed to update purchase: ${
//           error.response?.data?.message || error.message
//         }`,
//         3000,
//         "topRight"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Handle printing the purchase
//   const handlePrint = async () => {
//     if (!validateForm()) return;

//     setLoading(true);
//     try {
//       const payload = preparePayload();
//       const response = await axios.put(
//         `${ApiUrl}/Api/purchase_details.php/${id}`,
//         payload
//       );

//       if (response.status === 200 || response.status === 201) {
//         toast.success("Purchase saved for printing!", 3000, "topRight");
//         setShowModal(true);
//       } else {
//         toast.error(
//           response.data.message || "Failed to save purchase for print",
//           3000,
//           "topRight"
//         );
//       }
//     } catch (error) {
//       console.error("Print error:", error);
//       toast.error(
//         `Failed to save and print purchase: ${
//           error.response?.data?.message || error.message
//         }`,
//         3000,
//         "topRight"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Clear form
//   const handleClear = () => {
//     setUpdateData({
//       purchase_id: "",
//       purchase_date: new Date().toISOString().split("T")[0],
//       supplier_id: "",
//       return_type: "",
//       paid: "",
//       pure: "",
//       opening: "0.000",
//       current: "0.000",
//       close: "0.000",
//       total_pure: "0.000",
//       enter_amount: "",
//       items: [],
//       supplier_details: {
//         supplier_id: "",
//         name: null,
//         mobile: null,
//         address: null,
//       },
//     });
//     resetNewItem();
//     clearSupplier();
//     setSearchTerm("");
//   };

//   // Modal controls
//   const closeModal = () => {
//     setShowModal(false);
//     navigate(`/purchase-bill/${updateData.purchase_id}`);
//   };

//   return (
//     <>
//       {loading && (
//         <div className="loading-overlay">
//           <div className="loading-message">
//             <div className="loadinggif"></div>
//           </div>
//         </div>
//       )}
//       <div className="container-fluid py-2">
//         {/* Form Header */}
//         <div className="row">
//           <div className="col-lg-3">
//             <div className="card p-2">
//               <div className="row">
//                 <div className="col-md-6">
//                   <label className="form-label">Purchase ID</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     value={updateData.purchase_id}
//                     readOnly
//                   />
//                 </div>
//                 <div className="col-md-6">
//                   <label className="form-label">Date</label>
//                   <input
//                     type="date"
//                     className="form-control"
//                     value={updateData.purchase_date}
//                     onChange={(e) =>
//                       setUpdateData((prev) => ({
//                         ...prev,
//                         purchase_date: e.target.value,
//                       }))
//                     }
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="col-lg-9">
//             <div className="card p-2">
//               <div className="row g-3">
//                 <div className="col-md-3 position-relative">
//                   <label className="form-label">Supplier</label>
//                   <div className="input-group">
//                     <input
//                       type="text"
//                       className="form-control"
//                       placeholder="Search supplier..."
//                       value={searchTerm}
//                       disabled
//                       onChange={(e) => {
//                         setSearchTerm(e.target.value);
//                         setShowDropdown(true);
//                       }}
//                       onFocus={() => setShowDropdown(true)}
//                     />
//                     {searchTerm && (
//                       <button
//                         className="btn btn-outline-secondary h-75"
//                         type="button"
//                         onClick={clearSupplier}
//                         disabled
//                       >
//                         <i className="bi bi-x"></i>
//                       </button>
//                     )}
//                   </div>

//                   {showDropdown && suppliers.length > 0 && (
//                     <div className="dropdown-menu show w-100">
//                       {suppliers
//                         .filter(
//                           (supplier) =>
//                             supplier.supplier_id
//                               .toLowerCase()
//                               .includes(searchTerm.toLowerCase()) ||
//                             supplier.name
//                               .toLowerCase()
//                               .includes(searchTerm.toLowerCase())
//                         )
//                         .map((supplier) => (
//                           <button
//                             key={supplier.supplier_id}
//                             className="dropdown-item"
//                             onClick={() => handleSelectSupplier(supplier)}
//                             type="button"
//                           >
//                             {supplier.supplier_id} - {supplier.name}
//                           </button>
//                         ))}
//                     </div>
//                   )}
//                 </div>
//                 <div className="col-md-3">
//                   <label className="form-label">Supplier Name</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     style={{ opacity: 0.6, backgroundColor: "#f0f0f0" }}
//                     value={
//                       updateData.supplier_details?.name ||
//                       selectedSupplier?.name ||
//                       ""
//                     }
//                     disabled
//                   />
//                 </div>
//                 <div className="col-md-3">
//                   <label className="form-label">Mobile</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     style={{ opacity: 0.6, backgroundColor: "#f0f0f0" }}
//                     value={
//                       updateData.supplier_details?.mobile ||
//                       selectedSupplier?.mobile ||
//                       ""
//                     }
//                     disabled
//                   />
//                 </div>
//                 <div className="col-md-3">
//                   <label className="form-label">Address</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     style={{ opacity: 0.6, backgroundColor: "#f0f0f0" }}
//                     value={
//                       updateData.supplier_details?.address ||
//                       selectedSupplier?.address ||
//                       ""
//                     }
//                     disabled
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Item Entry Form */}
//         <div className="card p-2 mt-1">
//           <div className="row g-3">
//             <div className="col-md-2">
//               <label className="form-label">Item</label>
//               <select
//                 className="form-select"
//                 value={newItem.item}
//                 onChange={(e) =>
//                   setNewItem({
//                     ...newItem,
//                     item: e.target.value,
//                     type: e.target.value === "Bar" ? "" : newItem.type,
//                   })
//                 }
//               >
//                 <option value="">Select Item</option>
//                 <option value="Bar">Bar</option>
//                 <option value="Jewels">Jewels</option>
//                 <option value="Others">Others</option>
//               </select>
//             </div>

//             {newItem.item === "Others" && (
//               <div className="col-md-2">
//                 <label className="form-label">Others Name</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   placeholder="Others Name"
//                   value={newItem.other_name}
//                   onChange={(e) =>
//                     setNewItem({ ...newItem, other_name: e.target.value })
//                   }
//                 />
//               </div>
//             )}

//             <div className="col-md-2">
//               <label className="form-label">Category</label>
//               <select
//                 className="form-select"
//                 value={newItem.category}
//                 onChange={(e) =>
//                   setNewItem({ ...newItem, category: e.target.value })
//                 }
//               >
//                 <option value="">Select Category</option>
//                 <option value="Gold">Gold</option>
//                 <option value="Silver">Silver</option>
//               </select>
//             </div>
//             <div className="col-md-2">
//               <label className="form-label">Type</label>
//               <select
//                 className="form-select"
//                 value={newItem.type}
//                 onChange={(e) =>
//                   setNewItem({ ...newItem, type: e.target.value })
//                 }
//                 disabled={newItem.item === "Bar"}
//               >
//                 <option value="">Select Type</option>
//                 {Array.isArray(productTypes) &&
//                   productTypes.map((item) => (
//                     <option key={item._id} value={item.type}>
//                       {item.type}
//                     </option>
//                   ))}
//               </select>
//             </div>
//             <div className="col-md-1">
//               <label className="form-label">Qty</label>
//               <input
//                 type="text"
//                 inputMode="numeric"
//                 pattern="[0-9]*"
//                 maxLength="5"
//                 className="form-control"
//                 placeholder="Quantity"
//                 value={newItem.quantity}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   if (/^\d*$/.test(value)) {
//                     setNewItem({ ...newItem, quantity: value });
//                   }
//                 }}
//               />
//             </div>
//             <div className="col-md-1">
//               <label className="form-label">Weight (g)</label>
//               <input
//                 type="text"
//                 inputMode="decimal"
//                 className="form-control"
//                 placeholder="Weight"
//                 value={newItem.weight}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   if (/^\d*\.?\d*$/.test(value)) {
//                     setNewItem({ ...newItem, weight: value });
//                   }
//                 }}
//               />
//             </div>
//             <div className="col-md-1">
//               <label className="form-label">Purity (%)</label>
//               <input
//                 type="text"
//                 inputMode="decimal"
//                 className="form-control"
//                 placeholder="Purity"
//                 value={newItem.purity}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   if (/^\d{0,3}(\.\d{0,2})?$/.test(value)) {
//                     const numericValue = parseFloat(value);
//                     if (
//                       value === "" ||
//                       (!isNaN(numericValue) && numericValue <= 100)
//                     ) {
//                       setNewItem({ ...newItem, purity: value });
//                     } else {
//                       toast.error("Purity cannot exceed 100%", 3000, "topRight");
//                     }
//                   }
//                 }}
//                 disabled={newItem.item === "Bar"}
//               />
//             </div>
//             <div className="col-md-1">
//               <label className="form-label">Pure (g)</label>
//               <input
//                 type="text"
//                 className="form-control"
//                 value={newItem.pure || "0.000"}
//                 readOnly
//               />
//             </div>
//             <div className="col-md-1">
//               {editingItemId === null ? (
//                 <button
//                   className="btn btn-success btn-sm mx-2 mt-4"
//                   onClick={handleAddItem}
//                 >
//                   <i className="bi bi-plus"></i>
//                 </button>
//               ) : (
//                 <button
//                   className="btn btn-info btn-sm mx-2 mt-4"
//                   onClick={handleUpdateItem}
//                 >
//                   <i className="bi bi-check"></i>
//                 </button>
//               )}
//             </div>
//           </div>
//         </div>

//         {/* Items List */}
//         <div className="container-fluid p-2">
//           <div className="row">
//             <div className="col-lg-9">
//               <div className="card card-body p-2">
//                 <h6>Item List</h6>
//                 <div className="p-2" style={{ backgroundColor: "#E8F0FA" }}>
//                   <div className="table-container">
//                     <table className="table table-layout-fixed w-100">
//                       <thead className="bg-light">
//                         <tr>
//                           <th>S.No</th>
//                           <th>Item</th>
//                           <th>Category</th>
//                           <th>Type</th>
//                           <th>Quantity</th>
//                           <th>Weight(g)</th>
//                           <th>Purity (%)</th>
//                           <th>Pure(g)</th>
//                           <th>Action</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {updateData.items.length > 0 ? (
//                           updateData.items.map((item, index) => (
//                             <tr key={index}>
//                               <td>{index + 1}</td>
//                               <td>
//                                 {item.item}
//                                 {item.other_name ? ` (${item.other_name})` : ""}
//                               </td>
//                               <td>{item.category}</td>
//                               <td>{item.type || "-"}</td>
//                               <td>{item.quantity}</td>
//                               <td>{item.weight}g</td>
//                               <td>{item.purity}%</td>
//                               <td>{item.pure}g</td>
//                               <td>
//                                 <button
//                                   className="btn btn-sm btn-light me-1"
//                                   onClick={() => handleEditItem(item.id)}
//                                 >
//                                   <i className="fa-solid fa-pen-to-square text-primary fs-6"></i>
//                                 </button>
//                                 <button
//                                   className="btn btn-sm btn-light me-1"
//                                   onClick={() => handleRemoveItem(item.id)}
//                                 >
//                                   <i className="fa-solid fa-trash text-danger fs-6"></i>
//                                 </button>
//                               </td>
//                             </tr>
//                           ))
//                         ) : (
//                           <tr>
//                             <td colSpan="9" className="text-center">
//                               No items added yet
//                             </td>
//                           </tr>
//                         )}
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Summary Section */}
//             <div className="col-lg-3">
//               <div className="card p-3">
//                 <div className="row mb-3">
//                   <div className="col-md-6">
//                     <label className="form-label">Total Pure (g)</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       className="form-control"
//                       value={updateData.total_pure || "0.000"}
//                       readOnly
//                     />
//                   </div>
//                 </div>

//                 <div className="row mb-3">
//                   <div className="col-md-6">
//                     <label className="form-label">Return Type</label>
//                   </div>
//                   <div className="col-md-6">
//                     <select
//                       className="form-select"
//                       value={updateData.return_type || ""}
//                       onChange={(e) =>
//                         setUpdateData({
//                           ...updateData,
//                           return_type: e.target.value,
//                           paid: "",
//                           pure: "",
//                           enter_amount: "",
//                           current: updateData.opening,
//                           close: updateData.opening,
//                         })
//                       }
//                     >
//                       <option value="">Select Type</option>
//                       <option value="Pure">Pure</option>
//                       <option value="Amount">Amount</option>
//                     </select>
//                   </div>
//                 </div>

//                 {updateData.return_type === "Pure" && (
//                   <div className="row mb-3">
//                     <div className="col-md-6">
//                       <label className="form-label">Pure (g)</label>
//                     </div>
//                     <div className="col-md-6">
//                       <input
//                         type="text"
//                         inputMode="decimal"
//                         className="form-control"
//                         value={updateData.pure || ""}
//                         onChange={(e) => {
//                           const value = e.target.value;
//                           if (/^\d*\.?\d*$/.test(value)) {
//                             const numericValue = parseFloat(value);
//                             const totalPure = parseFloat(updateData.total_pure) || 0;
//                             if (
//                               value === "" ||
//                               (!isNaN(numericValue) && numericValue >= 0 && numericValue <= totalPure)
//                             ) {
//                               setUpdateData({ ...updateData, pure: value });
//                             } else {
//                               toast.error(
//                                 "Pure value must be between 0 and Total Pure",
//                                 3000,
//                                 "topRight"
//                               );
//                             }
//                           }
//                         }}
//                       />
//                     </div>
//                   </div>
//                 )}

//                 {updateData.return_type === "Amount" && (
//                   <>
//                     <div className="row mb-3">
//                       <div className="col-md-6">
//                         <label className="form-label">Enter Amount</label>
//                       </div>
//                       <div className="col-md-6">
//                         <input
//                           type="text"
//                           inputMode="decimal"
//                           className="form-control"
//                           value={updateData.enter_amount || ""}
//                           onChange={(e) => {
//                             const value = e.target.value;
//                             if (/^\d*\.?\d*$/.test(value)) {
//                               setUpdateData({ ...updateData, enter_amount: value });
//                             }
//                           }}
//                         />
//                       </div>
//                     </div>
//                     <div className="row mb-3">
//                       <div className="col-md-6">
//                         <label className="form-label">Paid</label>
//                       </div>
//                       <div className="col-md-6">
//                         <input
//                           type="text"
//                           inputMode="decimal"
//                           className="form-control"
//                           value={updateData.paid || ""}
//                           onChange={(e) => {
//                             const value = e.target.value;
//                             if (/^\d*\.?\d*$/.test(value)) {
//                               const numericValue = parseFloat(value);
//                               const enterAmount = parseFloat(updateData.enter_amount) || 0;
//                               const currentvalue = parseFloat(updateData.current) || 0;
//                               if (
//                                 value === "" ||
//                                 (!isNaN(numericValue) && numericValue >= 0 && numericValue <= currentvalue)
//                               ) {
//                                 setUpdateData({ ...updateData, paid: value });
//                               } else {
//                                 toast.error(
//                                   "Paid amount cannot exceed Enter Amount",
//                                   3000,
//                                   "topRight"
//                                 );
//                               }
//                             }
//                           }}
//                         />
//                       </div>
//                     </div>
//                   </>
//                 )}

//                 <div className="row mb-3">
//                   <div className="col-md-6">
//                     <label className="form-label">Opening</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       className="form-control"
//                       value={updateData.opening || "0.000"}
//                       readOnly
//                       style={{ opacity: 0.6, backgroundColor: "#f0f0f0" }}
//                     />
//                   </div>
//                 </div>
//                 <div className="row mb-3">
//                   <div className="col-md-6">
//                     <label className="form-label">Current</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       className="form-control"
//                       value={updateData.current || "0.000"}
//                       readOnly
//                     />
//                   </div>
//                 </div>
//                 <div className="row mb-3">
//                   <div className="col-md-6">
//                     <label className="form-label">Closing</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       className="form-control"
//                       value={updateData.close || "0.000"}
//                       readOnly
//                     />
//                   </div>
//                 </div>

//                 <div className="d-flex justify-content-between mt-2">
//                   <button
//                     className="btn btn-secondary btn-sm"
//                     onClick={() => navigate("/purchases")}
//                   >
//                     <i className="fa-solid fa-arrow-left"></i> Back
//                   </button>
//                   <button
//                     className="btn btn-danger btn-sm"
//                     onClick={handleClear}
//                   >
//                     <i className="bi bi-x-circle"></i> Clear
//                   </button>
//                   <button
//                     className="btn btn-primary btn-sm"
//                     onClick={handlePrint}
//                     disabled={loading}
//                   >
//                     <i className="bi bi-printer"></i> Print
//                   </button>
//                   <button
//                     className="btn btn-success btn-sm"
//                     onClick={handleUpdate}
//                     disabled={loading}
//                   >
//                     <i className="bi bi-save"></i> Update
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Print Confirmation Modal */}
//       <div
//         className={`modal fade ${showModal ? "show" : ""}`}
//         style={{ display: showModal ? "block" : "none" }}
//         tabIndex="-1"
//         aria-labelledby="printModalLabel"
//         aria-hidden={!showModal}
//       >
//         <div className="modal-dialog modal-dialog-centered">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h6 className="modal-title text-primary" id="printModalLabel">
//                 Print Confirmation
//               </h6>
//               <button
//                 type="button"
//                 className="btn-close"
//                 style={{ fontSize: "10px" }}
//                 onClick={() => setShowModal(false)}
//                 aria-label="Close"
//               ></button>
//             </div>
//             <div className="modal-body">
//               <div className="text-center">
//                 <p>Do you want to print the purchase bill?</p>
//               </div>
//               <div className="d-flex justify-content-center mt-4">
//                 <button
//                   type="button"
//                   className="btn btn-secondary btn-sm mx-2"
//                   onClick={() => navigate("/purchases")}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-primary btn-sm"
//                   onClick={closeModal}
//                   disabled={loading}
//                 >
//                   {loading ? "Processing..." : "Print"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {showModal && <div className="modal-backdrop fade show"></div>}
//     </>
//   );
// }

// export default UpdatePurchase;

// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import ApiUrl from "../Environment/ApiUrl";
// import { useToast } from "../Toast/ToastContext";

// function UpdatePurchase({ toggleSidebar }) {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const toast = useToast();
//   const [loading, setLoading] = useState(false);
//   const [showModal, setShowModal] = useState(false);
//   const [productTypes, setProductTypes] = useState([]);
//   const [suppliers, setSuppliers] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedSupplier, setSelectedSupplier] = useState(null);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const [editingItemId, setEditingItemId] = useState(null);

//   // Form data state
//   const [updateData, setUpdateData] = useState({
//     purchase_id: "",
//     purchase_date: new Date().toISOString().split("T")[0],
//     supplier_id: "",
//     return_type: "",
//     paid: "",
//     pure: "",
//     opening: "0.000",
//     current: "0.000",
//     close: "0.000",
//     total_pure: "0.000",
//     enter_amount: "",
//     items: [],
//     supplier_details: {
//       supplier_id: "",
//       name: null,
//       mobile: null,
//       address: null,
//     },
//   });

//   // New item state
//   const [newItem, setNewItem] = useState({
//     item: "",
//     category: "",
//     other_name: "",
//     type: "",
//     quantity: "",
//     weight: "",
//     purity: "",
//     pure: "0.000",
//     total_amount: "0.000",
//   });

//   // Calculate pure and total_amount for new item
//   useEffect(() => {
//     let pure = "0.000";
//     let total_amount = "0.000";

//     if (newItem.weight && newItem.purity && newItem.quantity) {
//       const weight = parseFloat(newItem.weight);
//       const purity = parseFloat(newItem.purity);
//       const quantity = parseFloat(newItem.quantity);

//       if (!isNaN(weight) && !isNaN(purity) && !isNaN(quantity)) {
//         if (purity > 100) {
//           toast.error("Purity cannot exceed 100%", 3000, "topRight");
//           setNewItem((prev) => ({ ...prev, purity: "" }));
//           return;
//         }
//         const singlePure = (weight * purity) / 100;
//         pure = (quantity * singlePure).toFixed(3);
//         total_amount = (quantity * weight * (purity / 100)).toFixed(3);
//       }
//     }

//     setNewItem((prev) => ({ ...prev, pure, total_amount }));
//   }, [newItem.weight, newItem.purity, newItem.quantity, toast]);

//   // Calculate total_pure from items
//   useEffect(() => {
//     const totalPure = updateData.items
//       .reduce((sum, item) => sum + parseFloat(item.pure || 0), 0)
//       .toFixed(3);
//     setUpdateData((prev) => ({ ...prev, total_pure: totalPure }));
//   }, [updateData.items]);

//   // Calculate current (opening + total_pure for Pure, opening + enter_amount for Amount)
//   useEffect(() => {
//     let current = "0.000";
//     const opening = parseFloat(updateData.opening) || 0;

//     if (updateData.return_type === "Pure") {
//       const totalPure = parseFloat(updateData.total_pure) || 0;
//       current = (opening + totalPure).toFixed(3);
//     } else if (updateData.return_type === "Amount") {
//       const enterAmount = parseFloat(updateData.enter_amount) || 0;
//       current = (opening + enterAmount).toFixed(3);
//     } else {
//       current = opening.toFixed(3);
//     }

//     setUpdateData((prev) => ({ ...prev, current }));
//   }, [updateData.total_pure, updateData.opening, updateData.enter_amount, updateData.return_type]);

//   // Calculate closing (total_pure - pure for Pure, opening + enter_amount - paid for Amount)
//   useEffect(() => {
//     let close = "0.000";

//     if (updateData.return_type === "Pure") {
//       const totalPure = parseFloat(updateData.total_pure) || 0;
//       const pure = parseFloat(updateData.pure) || 0;
//       if (pure > totalPure) {
//         toast.error("Pure value cannot exceed Total Pure", 3000, "topRight");
//         setUpdateData((prev) => ({ ...prev, pure: "" }));
//         close = totalPure.toFixed(3);
//       } else {
//         close = (totalPure - pure).toFixed(3);
//       }
//     } else if (updateData.return_type === "Amount") {
//       const opening = parseFloat(updateData.opening) || 0;
//       const enterAmount = parseFloat(updateData.enter_amount) || 0;
//       const paid = parseFloat(updateData.paid) || 0;
//       const current = parseFloat(updateData.current) || 0;

//       if (paid > current) {
//         toast.error("Paid amount cannot exceed Current", 3000, "topRight");
//         setUpdateData((prev) => ({ ...prev, paid: "" }));
//         close = current.toFixed(3);
//       } else {
//         close = (opening + enterAmount - paid).toFixed(3);
//       }
//     }

//     setUpdateData((prev) => ({ ...prev, close }));
//   }, [updateData.total_pure, updateData.pure, updateData.enter_amount, updateData.paid, updateData.return_type, updateData.opening, toast]);

//   // Reset type when item is "Bar"
//   useEffect(() => {
//     if (newItem.item === "Bar") {
//       setNewItem((prev) => ({ ...prev, type: "", purity: "100" }));
//     }
//   }, [newItem.item]);

//   // Fetch data on component mount
//   useEffect(() => {
//     if (toggleSidebar) toggleSidebar();
//     fetchProductTypes();
//     fetchSuppliers();
//     if (id) {
//       fetchPurchaseData();
//     }
//   }, [id]);

//   // Fetch purchase data
//   const fetchPurchaseData = async () => {
//     setLoading(true);
//     try {
//       const response = await axios.get(
//         `${ApiUrl}/Api/purchase_details.php/${id}`
//       );
//       const purchaseData = response.data.data[0];

//       if (purchaseData) {
//         setUpdateData({
//           purchase_id: purchaseData.purchase_id,
//           purchase_date: purchaseData.purchase_date,
//           supplier_id: purchaseData.supplier_id,
//           return_type: purchaseData.return_type,
//           paid: purchaseData.paid || "",
//           pure: purchaseData.pure || "",
//           opening: parseFloat(purchaseData.opening).toFixed(3) || "0.000",
//           current: parseFloat(purchaseData.current).toFixed(3) || "0.000",
//           close: parseFloat(purchaseData.close).toFixed(3) || "0.000",
//           total_pure: parseFloat(purchaseData.total_pure).toFixed(3) || "0.000",
//           enter_amount: purchaseData.enter_amount || "",
//           items: purchaseData.items.map((item, index) => ({
//             id: index + 1,
//             purchase_id: item.purchase_id,
//             item: item.item,
//             other_name: item.other_name || "",
//             category: item.category,
//             type: item.type || "",
//             quantity: parseFloat(item.quantity) || 0,
//             weight: parseFloat(item.weight) || 0,
//             purity: parseFloat(item.percentage) || 0,
//             pure: parseFloat(item.pure) || 0,
//             total_amount: parseFloat(item.total_amount) || 0,
//           })),
//           supplier_details: {
//             supplier_id: purchaseData.supplier.supplier_id,
//             name: purchaseData.supplier.name,
//             mobile: purchaseData.supplier.mobile,
//             address: purchaseData.supplier.address,
//           },
//         });
//         setSelectedSupplier(purchaseData.supplier);
//         setSearchTerm(
//           `${purchaseData.supplier.supplier_id} - ${purchaseData.supplier.name}`
//         );
//       }
//     } catch (error) {
//       console.error("Error fetching purchase data:", error);
//       toast.error("Failed to load purchase data", 3000, "topRight");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Fetch product types
//   const fetchProductTypes = async () => {
//     try {
//       const response = await axios.get(`${ApiUrl}/Api/product_type.php`);
//       setProductTypes(response.data?.data || []);
//     } catch (error) {
//       console.error("Error fetching product types:", error);
//       toast.error("Failed to fetch product types", 3000, "topRight");
//     }
//   };

//   // Fetch suppliers
//   const fetchSuppliers = async () => {
//     try {
//       const response = await axios.get(`${ApiUrl}/Api/supplier.php`);
//       setSuppliers(response.data?.data || []);
//     } catch (error) {
//       console.error("Error fetching suppliers:", error);
//       toast.error("Failed to fetch suppliers", 3000, "topRight");
//     }
//   };

//   // Handle supplier selection and fetch supplier-specific opening balance
//   const handleSelectSupplier = async (supplier) => {
//     setSelectedSupplier(supplier);
//     setSearchTerm(`${supplier.supplier_id} - ${supplier.name}`);
//     setUpdateData((prev) => ({
//       ...prev,
//       supplier_id: supplier.supplier_id,
//       supplier_details: {
//         supplier_id: supplier.supplier_id,
//         name: supplier.name,
//         mobile: supplier.mobile,
//         address: supplier.address,
//       },
//     }));
//     setShowDropdown(false);

//     // Fetch supplier-specific opening balance based on return_type
//     try {
//       const response = await axios.get(`${ApiUrl}/Api/purchase_details.php`);
//       const supplierPurchases = response.data.data.filter(
//         (purchase) =>
//           purchase.supplier_id === supplier.supplier_id &&
//           purchase.return_type === updateData.return_type &&
//           purchase.purchase_id !== updateData.purchase_id
//       );
//       const totalOpening = supplierPurchases
//         .reduce((sum, purchase) => sum + parseFloat(purchase.close || 0), 0)
//         .toFixed(3);
//       setUpdateData((prev) => ({
//         ...prev,
//         opening: totalOpening || "0.000",
//       }));
//     } catch (error) {
//       console.error("Error fetching supplier purchases:", error);
//       setUpdateData((prev) => ({
//         ...prev,
//         opening: "0.000",
//       }));
//       // toast.error("Failed to fetch supplier opening balance", 3000, "topRight");
//     }
//   };

//   // Update opening balance when return_type changes
//   useEffect(() => {
//     if (selectedSupplier && updateData.return_type && updateData.purchase_id) {
//       const fetchOpeningBalance = async () => {
//         try {
//           const response = await axios.get(`${ApiUrl}/Api/purchase_details.php`);
//           const supplierPurchases = response.data.data.filter(
//             (purchase) =>
//               purchase.supplier_id === selectedSupplier.supplier_id &&
//               purchase.return_type === updateData.return_type &&
//               purchase.purchase_id !== updateData.purchase_id
//           );
//           const totalOpening = supplierPurchases
//             .reduce((sum, purchase) => sum + parseFloat(purchase.close || 0), 0)
//             .toFixed(3);
//           setUpdateData((prev) => ({
//             ...prev,
//             opening: totalOpening || "0.000",
//           }));
//         } catch (error) {
//           console.error("Error fetching supplier purchases for return_type:", error);
//           setUpdateData((prev) => ({
//             ...prev,
//             opening: "0.000",
//           }));
//           // toast.error("Failed to fetch opening balance", 3000, "topRight");
//         }
//       };
//       fetchOpeningBalance();
//     } else {
//       setUpdateData((prev) => ({
//         ...prev,
//         opening: "0.000",
//       }));
//     }
//   }, [updateData.return_type, selectedSupplier, updateData.purchase_id, toast]);

//   const clearSupplier = () => {
//     setSelectedSupplier(null);
//     setSearchTerm("");
//     setUpdateData((prev) => ({
//       ...prev,
//       supplier_id: "",
//       supplier_details: {
//         supplier_id: "",
//         name: null,
//         mobile: null,
//         address: null,
//       },
//       opening: "0.000",
//     }));
//   };

//   // Handle adding a new item
//   const handleAddItem = () => {
//     if (!validateItem()) return;

//     const newItems = [
//       ...updateData.items,
//       {
//         id: updateData.items.length + 1,
//         purchase_id: updateData.purchase_id,
//         item: newItem.item,
//         other_name: newItem.other_name,
//         category: newItem.category,
//         type: newItem.type,
//         quantity: parseFloat(newItem.quantity) || 0,
//         weight: parseFloat(newItem.weight) || 0,
//         purity: parseFloat(newItem.purity) || 0,
//         pure: parseFloat(newItem.pure) || 0,
//         total_amount: parseFloat(newItem.total_amount) || 0,
//       },
//     ];

//     setUpdateData((prev) => ({ ...prev, items: newItems }));
//     resetNewItem();
//   };

//   // Validate new item
//   const validateItem = () => {
//     if (!newItem.item) {
//       toast.error("Please select an item", 3000, "topRight");
//       return false;
//     }
//     if (!newItem.category) {
//       toast.error("Please select a category", 3000, "topRight");
//       return false;
//     }
//     if (newItem.item !== "Bar" && !newItem.type) {
//       toast.error("Please select a type", 3000, "topRight");
//       return false;
//     }
//     if (!newItem.quantity || parseFloat(newItem.quantity) <= 0) {
//       toast.error("Please enter a valid quantity", 3000, "topRight");
//       return false;
//     }
//     if (!newItem.weight || parseFloat(newItem.weight) <= 0) {
//       toast.error("Please enter a valid weight", 3000, "topRight");
//       return false;
//     }
//     if (
//       !newItem.purity ||
//       parseFloat(newItem.purity) <= 0 ||
//       parseFloat(newItem.purity) > 100
//     ) {
//       toast.error("Please enter a valid purity (0-100%)", 3000, "topRight");
//       return false;
//     }
//     if (newItem.item === "Others" && !newItem.other_name) {
//       toast.error("Please enter a name for 'Others'", 3000, "topRight");
//       return false;
//     }
//     return true;
//   };

//   // Reset new item form
//   const resetNewItem = () => {
//     setNewItem({
//       item: "",
//       category: "",
//       other_name: "",
//       type: "",
//       quantity: "",
//       weight: "",
//       purity: "",
//       pure: "0.000",
//       total_amount: "0.000",
//     });
//     setEditingItemId(null);
//   };

//   // Handle removing an item
//   const handleRemoveItem = (itemId) => {
//     const updatedItems = updateData.items
//       .filter((item) => item.id !== itemId)
//       .map((item, index) => ({ ...item, id: index + 1 }));
//     setUpdateData((prev) => ({ ...prev, items: updatedItems }));
//   };

//   // Handle editing an item
//   const handleEditItem = (itemId) => {
//     const itemToEdit = updateData.items.find((item) => item.id === itemId);
//     if (itemToEdit) {
//       setNewItem({
//         item: itemToEdit.item,
//         category: itemToEdit.category,
//         other_name: itemToEdit.other_name,
//         type: itemToEdit.type,
//         quantity: itemToEdit.quantity.toString(),
//         weight: itemToEdit.weight.toString(),
//         purity: itemToEdit.purity.toString(),
//         pure: itemToEdit.pure.toFixed(3),
//         total_amount: itemToEdit.total_amount.toFixed(3),
//       });
//       setEditingItemId(itemId);
//     }
//   };

//   // Handle updating an item
//   const handleUpdateItem = () => {
//     if (!validateItem() || editingItemId === null) return;

//     const updatedItems = updateData.items.map((item) =>
//       item.id === editingItemId
//         ? {
//             ...item,
//             item: newItem.item,
//             purchase_id: updateData.purchase_id,
//             category: newItem.category,
//             other_name: newItem.other_name,
//             type: newItem.type,
//             quantity: parseFloat(newItem.quantity) || 0,
//             weight: parseFloat(newItem.weight) || 0,
//             purity: parseFloat(newItem.purity) || 0,
//             pure: parseFloat(newItem.pure) || 0,
//             total_amount: parseFloat(newItem.total_amount) || 0,
//           }
//         : item
//     );

//     setUpdateData((prev) => ({ ...prev, items: updatedItems }));
//     resetNewItem();
//   };

//   // Validate form before save or print
//   const validateForm = () => {
//     if (!updateData.purchase_id) {
//       toast.error("Purchase ID is required", 3000, "topRight");
//       return false;
//     }
//     if (!updateData.purchase_date) {
//       toast.error("Purchase date is required", 3000, "topRight");
//       return false;
//     }
//     if (!updateData.supplier_id) {
//       toast.error("Please select a supplier", 3000, "topRight");
//       return false;
//     }
//     if (updateData.items.length === 0) {
//       toast.error("Please add at least one item", 3000, "topRight");
//       return false;
//     }
//     if (
//       updateData.return_type === "Pure" &&
//       (!updateData.pure || parseFloat(updateData.pure) < 0)
//     ) {
//       toast.error("Please enter a valid pure value", 3000, "topRight");
//       return false;
//     }
//     if (
//       updateData.return_type === "Amount" &&
//       (!updateData.enter_amount || parseFloat(updateData.enter_amount) <= 0)
//     ) {
//       toast.error("Please enter a valid amount to pay", 3000, "topRight");
//       return false;
//     }
//     if (
//       updateData.return_type === "Amount" &&
//       (!updateData.paid || parseFloat(updateData.paid) < 0)
//     ) {
//       toast.error("Please enter a valid paid amount", 3000, "topRight");
//       return false;
//     }
//     if (
//       updateData.return_type === "Amount" &&
//       parseFloat(updateData.paid) > parseFloat(updateData.current)
//     ) {
//       toast.error("Paid amount cannot exceed Current", 3000, "topRight");
//       return false;
//     }
//     return true;
//   };

//   // Prepare payload for API
//   const preparePayload = () => {
//     let payload = {
//       purchase_id: updateData.purchase_id,
//       purchase_date: updateData.purchase_date,
//       supplier_id: updateData.supplier_id,
//       return_type: updateData.return_type,
//       paid: parseFloat(updateData.paid) || 0,
//       pure: parseFloat(updateData.pure) || 0,
//       opening: parseFloat(updateData.opening) || 0,
//       current: parseFloat(updateData.current) || 0,
//       close: parseFloat(updateData.close) || 0,
//       total_pure: parseFloat(updateData.total_pure) || 0,
//       enter_amount: parseFloat(updateData.enter_amount) || 0,
//       items: updateData.items.map((item) => ({
//         category: item.category,
//         quantity: parseFloat(item.quantity) || 0,
//         item: item.item,
//         weight: parseFloat(item.weight) || 0,
//         type: item.type,
//         other_name: item.other_name || "",
//         percentage: parseFloat(item.purity) || 0,
//         pure: parseFloat(item.pure) || 0,
//         total_amount: parseFloat(item.total_amount) || 0,
//         purchase_id: updateData.purchase_id,
//       })),
//     };

//     if (updateData.return_type === "Pure") {
//       payload.paid = 0;
//       payload.enter_amount = 0;
//     } else if (updateData.return_type === "Amount") {
//       payload.pure = 0;
//     } else {
//       payload.pure = 0;
//       payload.paid = 0;
//       payload.enter_amount = 0;
//     }

//     return payload;
//   };

//   // Handle saving the updated purchase
//   const handleUpdate = async () => {
//     if (!validateForm()) return;

//     setLoading(true);
//     try {
//       const payload = preparePayload();
//       const response = await axios.put(
//         `${ApiUrl}/Api/purchase_details.php/${id}`,
//         payload
//       );

//       if (response.status === 200 || response.status === 201) {
//         toast.success("Purchase updated successfully!", 3000, "topRight");
//         navigate("/purchases");
//       } else {
//         toast.error(
//           response.data.message || "Failed to update purchase",
//           3000,
//           "topRight"
//         );
//       }
//     } catch (error) {
//       console.error("Error updating purchase:", error);
//       toast.error(
//         `Failed to update purchase: ${
//           error.response?.data?.message || error.message
//         }`,
//         3000,
//         "topRight"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Handle printing the purchase
//   const handlePrint = async () => {
//     if (!validateForm()) return;

//     setLoading(true);
//     try {
//       const payload = preparePayload();
//       const response = await axios.put(
//         `${ApiUrl}/Api/purchase_details.php/${id}`,
//         payload
//       );

//       if (response.status === 200 || response.status === 201) {
//         toast.success("Purchase saved for printing!", 3000, "topRight");
//         setShowModal(true);
//       } else {
//         toast.error(
//           response.data.message || "Failed to save purchase for print",
//           3000,
//           "topRight"
//         );
//       }
//     } catch (error) {
//       console.error("Print error:", error);
//       toast.error(
//         `Failed to save and print purchase: ${
//           error.response?.data?.message || error.message
//         }`,
//         3000,
//         "topRight"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Clear form
//   const handleClear = () => {
//     setUpdateData({
//       purchase_id: "",
//       purchase_date: new Date().toISOString().split("T")[0],
//       supplier_id: "",
//       return_type: "",
//       paid: "",
//       pure: "",
//       opening: "0.000",
//       current: "0.000",
//       close: "0.000",
//       total_pure: "0.000",
//       enter_amount: "",
//       items: [],
//       supplier_details: {
//         supplier_id: "",
//         name: null,
//         mobile: null,
//         address: null,
//       },
//     });
//     resetNewItem();
//     clearSupplier();
//     setSearchTerm("");
//   };

//   // Modal controls
//   const closeModal = () => {
//     setShowModal(false);
//     navigate(`/purchase-bill/${updateData.purchase_id}`);
//   };

//   return (
//     <>
//       {loading && (
//         <div className="loading-overlay">
//           <div className="loading-message">
//             <div className="loadinggif"></div>
//           </div>
//         </div>
//       )}
//       <div className="container-fluid py-2">
//         {/* Form Header */}
//         <div className="row">
//           <div className="col-lg-3">
//             <div className="card p-2">
//               <div className="row">
//                 <div className="col-md-6">
//                   <label className="form-label">Purchase ID</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     value={updateData.purchase_id}
//                     readOnly
//                   />
//                 </div>
//                 <div className="col-md-6">
//                   <label className="form-label">Date</label>
//                   <input
//                     type="date"
//                     className="form-control"
//                     value={updateData.purchase_date}
//                     onChange={(e) =>
//                       setUpdateData((prev) => ({
//                         ...prev,
//                         purchase_date: e.target.value,
//                       }))
//                     }
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="col-lg-9">
//             <div className="card p-2">
//               <div className="row g-3">
//                 <div className="col-md-3 position-relative">
//                   <label className="form-label">Supplier</label>
//                   <div className="input-group">
//                     <input
//                       type="text"
//                       className="form-control"
//                       placeholder="Search supplier..."
//                       value={searchTerm}
//                       disabled
//                       onChange={(e) => {
//                         setSearchTerm(e.target.value);
//                         setShowDropdown(true);
//                       }}
//                       onFocus={() => setShowDropdown(true)}
//                     />
//                     {searchTerm && (
//                       <button
//                         className="btn btn-outline-secondary h-75"
//                         type="button"
//                         onClick={clearSupplier}
//                         disabled
//                       >
//                         <i className="bi bi-x"></i>
//                       </button>
//                     )}
//                   </div>

//                   {showDropdown && suppliers.length > 0 && (
//                     <div className="dropdown-menu show w-100">
//                       {suppliers
//                         .filter(
//                           (supplier) =>
//                             supplier.supplier_id
//                               .toLowerCase()
//                               .includes(searchTerm.toLowerCase()) ||
//                             supplier.name
//                               .toLowerCase()
//                               .includes(searchTerm.toLowerCase())
//                         )
//                         .map((supplier) => (
//                           <button
//                             key={supplier.supplier_id}
//                             className="dropdown-item"
//                             onClick={() => handleSelectSupplier(supplier)}
//                             type="button"
//                           >
//                             {supplier.supplier_id} - {supplier.name}
//                           </button>
//                         ))}
//                     </div>
//                   )}
//                 </div>
//                 <div className="col-md-3">
//                   <label className="form-label">Supplier Name</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     style={{ opacity: 0.6, backgroundColor: "#f0f0f0" }}
//                     value={
//                       updateData.supplier_details?.name ||
//                       selectedSupplier?.name ||
//                       ""
//                     }
//                     disabled
//                   />
//                 </div>
//                 <div className="col-md-3">
//                   <label className="form-label">Mobile</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     style={{ opacity: 0.6, backgroundColor: "#f0f0f0" }}
//                     value={
//                       updateData.supplier_details?.mobile ||
//                       selectedSupplier?.mobile ||
//                       ""
//                     }
//                     disabled
//                   />
//                 </div>
//                 <div className="col-md-3">
//                   <label className="form-label">Address</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     style={{ opacity: 0.6, backgroundColor: "#f0f0f0" }}
//                     value={
//                       updateData.supplier_details?.address ||
//                       selectedSupplier?.address ||
//                       ""
//                     }
//                     disabled
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Item Entry Form */}
//         <div className="card p-2 mt-1">
//           <div className="row g-3">
//             <div className="col-md-2">
//               <label className="form-label">Item</label>
//               <select
//                 className="form-select"
//                 value={newItem.item}
//                 onChange={(e) =>
//                   setNewItem({
//                     ...newItem,
//                     item: e.target.value,
//                     type: e.target.value === "Bar" ? "" : newItem.type,
//                   })
//                 }
//               >
//                 <option value="">Select Item</option>
//                 <option value="Bar">Bar</option>
//                 <option value="Jewels">Jewels</option>
//                 <option value="Others">Others</option>
//               </select>
//             </div>

//             {newItem.item === "Others" && (
//               <div className="col-md-2">
//                 <label className="form-label">Others Name</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   placeholder="Others Name"
//                   value={newItem.other_name}
//                   onChange={(e) =>
//                     setNewItem({ ...newItem, other_name: e.target.value })
//                   }
//                 />
//               </div>
//             )}

//             <div className="col-md-2">
//               <label className="form-label">Category</label>
//               <select
//                 className="form-select"
//                 value={newItem.category}
//                 onChange={(e) =>
//                   setNewItem({ ...newItem, category: e.target.value })
//                 }
//               >
//                 <option value="">Select Category</option>
//                 <option value="Gold">Gold</option>
//                 <option value="Silver">Silver</option>
//               </select>
//             </div>
//             <div className="col-md-2">
//               <label className="form-label">Type</label>
//               <select
//                 className="form-select"
//                 value={newItem.type}
//                 onChange={(e) =>
//                   setNewItem({ ...newItem, type: e.target.value })
//                 }
//                 disabled={newItem.item === "Bar"}
//               >
//                 <option value="">Select Type</option>
//                 {Array.isArray(productTypes) &&
//                   productTypes.map((item) => (
//                     <option key={item._id} value={item.type}>
//                       {item.type}
//                     </option>
//                   ))}
//               </select>
//             </div>
//             <div className="col-md-1">
//               <label className="form-label">Qty</label>
//               <input
//                 type="text"
//                 inputMode="numeric"
//                 pattern="[0-9]*"
//                 maxLength="5"
//                 className="form-control"
//                 placeholder="Quantity"
//                 value={newItem.quantity}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   if (/^\d*$/.test(value)) {
//                     setNewItem({ ...newItem, quantity: value });
//                   }
//                 }}
//               />
//             </div>
//             <div className="col-md-1">
//               <label className="form-label">Weight (g)</label>
//               <input
//                 type="text"
//                 inputMode="decimal"
//                 className="form-control"
//                 placeholder="Weight"
//                 value={newItem.weight}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   if (/^\d*\.?\d*$/.test(value)) {
//                     setNewItem({ ...newItem, weight: value });
//                   }
//                 }}
//               />
//             </div>
//             <div className="col-md-1">
//               <label className="form-label">Purity (%)</label>
//               <input
//                 type="text"
//                 inputMode="decimal"
//                 className="form-control"
//                 placeholder="Purity"
//                 value={newItem.purity}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   if (/^\d{0,3}(\.\d{0,2})?$/.test(value)) {
//                     const numericValue = parseFloat(value);
//                     if (
//                       value === "" ||
//                       (!isNaN(numericValue) && numericValue <= 100)
//                     ) {
//                       setNewItem({ ...newItem, purity: value });
//                     } else {
//                       toast.error("Purity cannot exceed 100%", 3000, "topRight");
//                     }
//                   }
//                 }}
//                 disabled={newItem.item === "Bar"}
//               />
//             </div>
//             <div className="col-md-1">
//               <label className="form-label">Pure (g)</label>
//               <input
//                 type="text"
//                 className="form-control"
//                 value={newItem.pure || "0.000"}
//                 readOnly
//               />
//             </div>
//             <div className="col-md-1">
//               {editingItemId === null ? (
//                 <button
//                   className="btn btn-success btn-sm mx-2 mt-4"
//                   onClick={handleAddItem}
//                 >
//                   <i className="bi bi-plus"></i>
//                 </button>
//               ) : (
//                 <button
//                   className="btn btn-info btn-sm mx-2 mt-4"
//                   onClick={handleUpdateItem}
//                 >
//                   <i className="bi bi-check"></i>
//                 </button>
//               )}
//             </div>
//           </div>
//         </div>

//         {/* Items List */}
//         <div className="container-fluid p-2">
//           <div className="row">
//             <div className="col-lg-9">
//               <div className="card card-body p-2">
//                 <h6>Item List</h6>
//                 <div className="p-2" style={{ backgroundColor: "#E8F0FA" }}>
//                   <div className="table-container">
//                     <table className="table table-layout-fixed w-100">
//                       <thead className="bg-light">
//                         <tr>
//                           <th>S.No</th>
//                           <th>Item</th>
//                           <th>Category</th>
//                           <th>Type</th>
//                           <th>Quantity</th>
//                           <th>Weight(g)</th>
//                           <th>Purity (%)</th>
//                           <th>Pure(g)</th>
//                           <th>Action</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {updateData.items.length > 0 ? (
//                           updateData.items.map((item, index) => (
//                             <tr key={index}>
//                               <td>{index + 1}</td>
//                               <td>
//                                 {item.item}
//                                 {item.other_name ? ` (${item.other_name})` : ""}
//                               </td>
//                               <td>{item.category}</td>
//                               <td>{item.type || "-"}</td>
//                               <td>{item.quantity}</td>
//                               <td>{item.weight}g</td>
//                               <td>{item.purity}%</td>
//                               <td>{item.pure}g</td>
//                               <td>
//                                 <button
//                                   className="btn btn-sm btn-light me-1"
//                                   onClick={() => handleEditItem(item.id)}
//                                 >
//                                   <i className="fa-solid fa-pen-to-square text-primary fs-6"></i>
//                                 </button>
//                                 <button
//                                   className="btn btn-sm btn-light me-1"
//                                   onClick={() => handleRemoveItem(item.id)}
//                                 >
//                                   <i className="fa-solid fa-trash text-danger fs-6"></i>
//                                 </button>
//                               </td>
//                             </tr>
//                           ))
//                         ) : (
//                           <tr>
//                             <td colSpan="9" className="text-center">
//                               No items added yet
//                             </td>
//                           </tr>
//                         )}
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Summary Section */}
//             <div className="col-lg-3">
//               <div className="card p-3">
//                 <div className="row mb-3">
//                   <div className="col-md-6">
//                     <label className="form-label">Total Pure (g)</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       className="form-control"
//                       value={updateData.total_pure || "0.000"}
//                       readOnly
//                     />
//                   </div>
//                 </div>

//                 <div className="row mb-3">
//                   <div className="col-md-6">
//                     <label className="form-label">Return Type</label>
//                   </div>
//                   <div className="col-md-6">
//                     <select
//                       className="form-select"
//                       value={updateData.return_type || ""}
//                       onChange={(e) =>
//                         setUpdateData({
//                           ...updateData,
//                           return_type: e.target.value,
//                           paid: "",
//                           pure: "",
//                           enter_amount: "",
//                           current: updateData.opening,
//                           close: updateData.opening,
//                         })
//                       }
//                     >
//                       <option value="">Select Type</option>
//                       <option value="Pure">Pure</option>
//                       <option value="Amount">Amount</option>
//                     </select>
//                   </div>
//                 </div>

//                 {updateData.return_type === "Pure" && (
//                   <div className="row mb-3">
//                     <div className="col-md-6">
//                       <label className="form-label">Pure (g)</label>
//                     </div>
//                     <div className="col-md-6">
//                       <input
//                         type="text"
//                         inputMode="decimal"
//                         className="form-control"
//                         value={updateData.pure || ""}
//                         onChange={(e) => {
//                           const value = e.target.value;
//                           if (/^\d*\.?\d*$/.test(value)) {
//                             const numericValue = parseFloat(value);
//                             const totalPure = parseFloat(updateData.total_pure) || 0;
//                             if (
//                               value === "" ||
//                               (!isNaN(numericValue) && numericValue >= 0 && numericValue <= totalPure)
//                             ) {
//                               setUpdateData({ ...updateData, pure: value });
//                             } else {
//                               toast.error(
//                                 "Pure value must be between 0 and Total Pure",
//                                 3000,
//                                 "topRight"
//                               );
//                             }
//                           }
//                         }}
//                       />
//                     </div>
//                   </div>
//                 )}

//                 {updateData.return_type === "Amount" && (
//                   <>
//                     <div className="row mb-3">
//                       <div className="col-md-6">
//                         <label className="form-label">Enter Amount</label>
//                       </div>
//                       <div className="col-md-6">
//                         <input
//                           type="text"
//                           inputMode="decimal"
//                           className="form-control"
//                           value={updateData.enter_amount || ""}
//                           onChange={(e) => {
//                             const value = e.target.value;
//                             if (/^\d*\.?\d*$/.test(value)) {
//                               setUpdateData({ ...updateData, enter_amount: value });
//                             }
//                           }}
//                         />
//                       </div>
//                     </div>
//                     <div className="row mb-3">
//                       <div className="col-md-6">
//                         <label className="form-label">Paid</label>
//                       </div>
//                       <div className="col-md-6">
//                         <input
//                           type="text"
//                           inputMode="decimal"
//                           className="form-control"
//                           value={updateData.paid || ""}
//                           onChange={(e) => {
//                             const value = e.target.value;
//                             if (/^\d*\.?\d*$/.test(value)) {
//                               const numericValue = parseFloat(value);
//                               const current = parseFloat(updateData.current) || 0;
//                               if (
//                                 value === "" ||
//                                 (!isNaN(numericValue) && numericValue >= 0 && numericValue <= current)
//                               ) {
//                                 setUpdateData({ ...updateData, paid: value });
//                               } else {
//                                 toast.error(
//                                   "Paid amount cannot exceed Current",
//                                   3000,
//                                   "topRight"
//                                 );
//                               }
//                             }
//                           }}
//                         />
//                       </div>
//                     </div>
//                   </>
//                 )}

//                 <div className="row mb-3">
//                   <div className="col-md-6">
//                     <label className="form-label">Opening</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       className="form-control"
//                       value={updateData.opening || "0.000"}
//                       readOnly
//                       style={{ opacity: 0.6, backgroundColor: "#f0f0f0" }}
//                     />
//                   </div>
//                 </div>
//                 <div className="row mb-3">
//                   <div className="col-md-6">
//                     <label className="form-label">Current</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       className="form-control"
//                       value={updateData.current || "0.000"}
//                       readOnly
//                     />
//                   </div>
//                 </div>
//                 <div className="row mb-3">
//                   <div className="col-md-6">
//                     <label className="form-label">Closing</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       className="form-control"
//                       value={updateData.close || "0.000"}
//                       readOnly
//                     />
//                   </div>
//                 </div>

//                 <div className="d-flex justify-content-between mt-2">
//                   <button
//                     className="btn btn-secondary btn-sm"
//                     onClick={() => navigate("/purchases")}
//                   >
//                     <i className="fa-solid fa-arrow-left"></i> Back
//                   </button>
//                   <button
//                     className="btn btn-danger btn-sm"
//                     onClick={handleClear}
//                   >
//                     <i className="bi bi-x-circle"></i> Clear
//                   </button>
//                   <button
//                     className="btn btn-primary btn-sm"
//                     onClick={handlePrint}
//                     disabled={loading}
//                   >
//                     <i className="bi bi-printer"></i> Print
//                   </button>
//                   <button
//                     className="btn btn-success btn-sm"
//                     onClick={handleUpdate}
//                     disabled={loading}
//                   >
//                     <i className="bi bi-save"></i> Update
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Print Confirmation Modal */}
//       <div
//         className={`modal fade ${showModal ? "show" : ""}`}
//         style={{ display: showModal ? "block" : "none" }}
//         tabIndex="-1"
//         aria-labelledby="printModalLabel"
//         aria-hidden={!showModal}
//       >
//         <div className="modal-dialog modal-dialog-centered">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h6 className="modal-title text-primary" id="printModalLabel">
//                 Print Confirmation
//               </h6>
//               <button
//                 type="button"
//                 className="btn-close"
//                 style={{ fontSize: "10px" }}
//                 onClick={() => setShowModal(false)}
//                 aria-label="Close"
//               ></button>
//             </div>
//             <div className="modal-body">
//               <div className="text-center">
//                 <p>Do you want to print the purchase bill?</p>
//               </div>
//               <div className="d-flex justify-content-center mt-4">
//                 <button
//                   type="button"
//                   className="btn btn-secondary btn-sm mx-2"
//                   onClick={() => navigate("/purchases")}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-primary btn-sm"
//                   onClick={closeModal}
//                   disabled={loading}
//                 >
//                   {loading ? "Processing..." : "Print"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {showModal && <div className="modal-backdrop fade show"></div>}
//     </>
//   );
// }

// export default UpdatePurchase;




import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ApiUrl from "../Environment/ApiUrl";
import { useToast } from "../Toast/ToastContext";

function UpdatePurchase({ toggleSidebar }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const toast = useToast();
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [productTypes, setProductTypes] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [supplierPaymentHistory, setSupplierPaymentHistory] = useState([]);
  const [loadingPaymentHistory, setLoadingPaymentHistory] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [editingItemId, setEditingItemId] = useState(null);
  const [returnPureCalculated, setReturnPureCalculated] = useState("0.000");
  const [adjustmentInput, setAdjustmentInput] = useState(""); // Temp input for +/– buttons

  const [todayRates, setTodayRates] = useState({
    gold_pure_rate: 0,
    silver_pure_rate: 0,
    date: "",
  });

  const [updateData, setUpdateData] = useState({
    purchase_id: "",
    purchase_date: new Date().toISOString().split("T")[0],
    supplier_id: "",
    return_type: "",
    paid: "",
    pure: "",
    opening: "0.000",
    current: "0.000",
    close: "0.000",
    total_pure: "0.000",
    enter_amount: "",
    items: [],
    supplier_details: {
      supplier_id: "",
      name: null,
      mobile: null,
      address: null,
    },
  });

  const [newItem, setNewItem] = useState({
    item: "",
    category: "",
    other_name: "",
    item_name: "", // Add this
    item_name_tamil: "", // Add this
    type: "",
    quantity: 1,
    weight: "",
    purity: "",
    pure: "0.000",
    total_amount: "0.000",
    adjustment: "0.000",
  });

const fetchProducts = async () => {
  try {
    const response = await axios.get(`${ApiUrl}/Api/product.php`);
    setProducts(response.data?.data || []);
  } catch (err) {
    toast.error("Failed to fetch products", 3000, "topRight");
  }
};

  // Fetch today's rates
  const fetchTodayRates = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/daily_rates.php/current`);
      if (response.data.status && response.data.data) {
        const rates = response.data.data;
        setTodayRates({
          gold_pure_rate: parseFloat(rates.gold_pure_percentage) || 0,
          silver_pure_rate: parseFloat(rates.silver_pure_percentage) || 0,
        });
      }
    } catch (error) {
      console.error("Failed to fetch rates", error);
    }
  };

  // Calculate pure for new/editing item (includes adjustment)
  useEffect(() => {
    let pure = "0.000";
    let total_amount = "0.000";

    if (newItem.weight && newItem.purity && newItem.quantity) {
      const weight = parseFloat(newItem.weight) || 0;
      const purity = parseFloat(newItem.purity) || 0;
      const quantity = parseFloat(newItem.quantity) || 1;

      if (purity > 100) {
        toast.error("Purity cannot exceed 100%", 3000, "topRight");
        setNewItem((prev) => ({ ...prev, purity: "" }));
        return;
      }

      const singlePure = (weight * purity) / 100;
      let calculatedPure = quantity * singlePure;
      const adjustment = parseFloat(newItem.adjustment) || 0;
      calculatedPure += adjustment;

      pure = calculatedPure.toFixed(3);
      total_amount = (quantity * weight).toFixed(3);
    }

    setNewItem((prev) => ({ ...prev, pure, total_amount }));
  }, [
    newItem.weight,
    newItem.purity,
    newItem.quantity,
    newItem.adjustment,
    toast,
  ]);

  // Filter products based on selected category
useEffect(() => {
  if (newItem.category) {
    const filtered = products.filter(product => 
      product.category === newItem.category
    );
    setFilteredProducts(filtered);
    // Reset item_name when category changes (but preserve if editing existing item)
    if (!editingItemId) {
      setNewItem(prev => ({ ...prev, item_name: "", item_name_tamil: "" }));
    }
  } else {
    setFilteredProducts([]);
  }
}, [newItem.category, products]);

  // Total pure from all items
  useEffect(() => {
    const totalPure = updateData.items
      .reduce((sum, item) => sum + parseFloat(item.pure || 0), 0)
      .toFixed(3);
    setUpdateData((prev) => ({ ...prev, total_pure: totalPure }));
  }, [updateData.items]);

  // MAIN CALCULATION: Current & Closing (always grams)
  // "pure" is the single source of truth for how much was returned, in BOTH
  // Pure mode (typed directly) and Amount mode (converted from paid/rate by
  // the Paid field's onChange handler below, at the moment the user edits
  // it). We deliberately do NOT re-derive grams from paid/todayRate here,
  // because that would silently change an old bill's closing balance every
  // time it's opened for editing on a day with a different gold/silver rate.
  useEffect(() => {
    const opening = parseFloat(updateData.opening) || 0;
    const totalPure = parseFloat(updateData.total_pure) || 0;
    const current = (opening + totalPure).toFixed(3);

    const returnPureGrams = parseFloat(updateData.pure) || 0;

    let closing = (parseFloat(current) - returnPureGrams).toFixed(3);
    if (parseFloat(closing) < 0) closing = "0.000";

    setUpdateData((prev) => ({ ...prev, current, close: closing }));
  }, [
    updateData.opening,
    updateData.total_pure,
    updateData.pure,
  ]);

  // Enter amount (₹ value of purchased items) — total value regardless of
  // return_type, so it isn't blank/zero for Pure-mode returns.
  useEffect(() => {
    if (updateData.items.length === 0) {
      setUpdateData((prev) => ({ ...prev, enter_amount: "" }));
      return;
    }
    let goldPure = 0,
      silverPure = 0;
    updateData.items.forEach((item) => {
      const pure = parseFloat(item.pure) || 0;
      if ((item.category === "Gold" || item.category === "Gold Coin")) goldPure += pure;
      if ((item.category === "Silver" || item.category === "Silver Coin")) silverPure += pure;
    });
    const total = (
      goldPure * todayRates.gold_pure_rate +
      silverPure * todayRates.silver_pure_rate
    ).toFixed(2);
    setUpdateData((prev) => ({ ...prev, enter_amount: total }));
  }, [updateData.items, todayRates]);

  // Bar item handling
  useEffect(() => {
    if (newItem.item === "Bar") {
      setNewItem((prev) => ({ ...prev, type: "", purity: "100" }));
    }
  }, [newItem.item]);

  // Initial load
  useEffect(() => {
    if (toggleSidebar) toggleSidebar();
    fetchTodayRates();
    // fetchProductTypes();
    fetchProducts();
    fetchSuppliers();
    if (id) fetchPurchaseData();
  }, [id]);

  // const fetchProductTypes = async () => {
  //   try {
  //     const res = await axios.get(`${ApiUrl}/Api/product_type.php`);
  //     setProductTypes(res.data?.data || []);
  //   } catch (err) {
  //     toast.error("Failed to fetch product types", 3000, "topRight");
  //   }
  // };

  const fetchSuppliers = async () => {
    try {
      const res = await axios.get(`${ApiUrl}/Api/supplier.php`);
      setSuppliers(res.data?.data || []);
    } catch (err) {
      toast.error("Failed to fetch suppliers", 3000, "topRight");
    }
  };

  const fetchPurchaseData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${ApiUrl}/Api/purchase_details.php/${id}`,
      );
      const data = response.data.data[0];
      if (data) {
        setUpdateData({
          purchase_id: data.purchase_id,
          purchase_date: data.purchase_date,
          supplier_id: data.supplier_id,
          return_type: data.return_type,
          paid: data.paid || "",
          pure: data.pure || "",
          opening: parseFloat(data.opening || 0).toFixed(3),
          current: parseFloat(data.current || 0).toFixed(3),
          close: parseFloat(data.close || 0).toFixed(3),
          total_pure: parseFloat(data.total_pure || 0).toFixed(3),
          enter_amount: data.enter_amount || "",
          items: data.items.map((item, i) => ({
            id: i + 1,
            ...item,
            quantity: parseFloat(item.quantity) || 0,
            weight: parseFloat(item.weight) || 0,
            purity: parseFloat(item.percentage) || 0,
            pure: parseFloat(item.pure) || 0,
            total_amount: parseFloat(item.total_amount) || 0,
            adjustment: parseFloat(item.adjustment || 0).toFixed(3),
          })),
          supplier_details: { ...data.supplier },
        });
        setSelectedSupplier(data.supplier);
        setSearchTerm(`${data.supplier.supplier_id} - ${data.supplier.name}`);
      }
    } catch (err) {
      toast.error("Failed to load purchase", 3000, "topRight");
    } finally {
      setLoading(false);
    }
  };

  // Opening balance: intentionally NOT recalculated on the Update page.
  // The opening/current/close values were fixed at the time this purchase
  // was originally saved (fetchPurchaseData loads them from the record).
  // Re-deriving "opening" from other supplier purchases here was causing
  // it to reset to 0.000 whenever this bill was opened for editing.

  // Fetch this supplier's payment history for the SAME DATE as the bill
  // being edited (per request: when editing a bill, only show payment
  // history for that saved bill's date, not the full history).
  useEffect(() => {
    if (!selectedSupplier?.supplier_id || !updateData.purchase_date) {
      setSupplierPaymentHistory([]);
      return;
    }

    const fetchPaymentHistory = async () => {
      setLoadingPaymentHistory(true);
      try {
        const res = await axios.get(`${ApiUrl}/Api/purchase_details.php`);
        const purchases = res.data?.data || [];

        const history = purchases
          .filter(
            (p) =>
              p.supplier_id === selectedSupplier.supplier_id &&
              p.purchase_date === updateData.purchase_date &&
              p.id !== parseInt(id),
          )
          .sort(
            (a, b) => new Date(b.purchase_date) - new Date(a.purchase_date),
          );

        setSupplierPaymentHistory(history);
      } catch (err) {
        console.error("Error fetching supplier payment history", err);
        setSupplierPaymentHistory([]);
      } finally {
        setLoadingPaymentHistory(false);
      }
    };

    fetchPaymentHistory();
  }, [selectedSupplier?.supplier_id, updateData.purchase_date, id]);

  const handleSelectSupplier = async (supplier) => {
    setSelectedSupplier(supplier);
    setSearchTerm(`${supplier.supplier_id} - ${supplier.name}`);
    setUpdateData((prev) => ({
      ...prev,
      supplier_id: supplier.supplier_id,
      supplier_details: { ...supplier },
      opening: "0.000",
    }));
    setShowDropdown(false);
  };

  const clearSupplier = () => {
    setSelectedSupplier(null);
    setSearchTerm("");
    setUpdateData((prev) => ({
      ...prev,
      supplier_id: "",
      supplier_details: {
        supplier_id: "",
        name: null,
        mobile: null,
        address: null,
      },
      opening: "0.000",
    }));
  };

  const validateItem = () => {
    if (!newItem.item)
      return (toast.error("Select item", 3000, "topRight"), false);
    if (!newItem.category)
      return (toast.error("Select category", 3000, "topRight"), false);
    if (newItem.item !== "Bar" && !newItem.item_name)
      return (toast.error("Select Itemname", 3000, "topRight"), false);
    if (!newItem.quantity || parseFloat(newItem.quantity) <= 0)
      return (toast.error("Invalid quantity", 3000, "topRight"), false);
    if (!newItem.weight || parseFloat(newItem.weight) <= 0)
      return (toast.error("Invalid weight", 3000, "topRight"), false);
    if (
      !newItem.purity ||
      parseFloat(newItem.purity) <= 0 ||
      parseFloat(newItem.purity) > 100
    )
      return (toast.error("Purity 0-100%", 3000, "topRight"), false);
    if (newItem.item === "Others" && !newItem.other_name)
      return (toast.error("Enter others name", 3000, "topRight"), false);
    return true;
  };

  const handleAddItem = () => {
    if (!validateItem()) return;
    const items = [
      ...updateData.items,
      {
        id: updateData.items.length + 1,
        purchase_id: updateData.purchase_id,
        item: newItem.item,
        other_name: newItem.other_name,
        item_name: newItem.item_name || newItem.type || newItem.item, // Add this
        item_name_tamil: newItem.item_name_tamil || "", // Add this
        category: newItem.category,
        type: newItem.type,
        quantity: parseFloat(newItem.quantity),
        weight: parseFloat(newItem.weight),
        purity: parseFloat(newItem.purity),
        pure: parseFloat(newItem.pure),
        total_amount: parseFloat(newItem.total_amount),
        adjustment: parseFloat(newItem.adjustment || 0),
      },
    ];
    setUpdateData((prev) => ({ ...prev, items }));
    resetNewItem();
  };

  const resetNewItem = () => {
    setNewItem({
      item: "",
      category: "",
      other_name: "",
      item_name: "", // Add this
      item_name_tamil: "", // Add this
      type: "",
      quantity: 1,
      weight: "",
      purity: "",
      pure: "0.000",
      total_amount: "0.000",
      adjustment: "0.000",
    });
    setAdjustmentInput("");
    setEditingItemId(null);
  };

  const handleRemoveItem = (id) => {
    const items = updateData.items
      .filter((i) => i.id !== id)
      .map((i, idx) => ({ ...i, id: idx + 1 }));
    setUpdateData((prev) => ({ ...prev, items }));
  };

  const handleEditItem = (id) => {
    const item = updateData.items.find((i) => i.id === id);
    if (item) {
      setNewItem({
        ...item,
        quantity: item.quantity.toString(),
        weight: item.weight.toString(),
        purity: item.purity.toString(),
        adjustment: item.adjustment.toString(),
        item_name: item.item_name || item.type || item.item, // Add this
        item_name_tamil: item.item_name_tamil || "", // Add this
      });
      setEditingItemId(id);
    }
  };

  const handleUpdateItem = () => {
    if (!validateItem() || !editingItemId) return;
    const items = updateData.items.map((i) =>
      i.id === editingItemId
        ? {
            ...i,
            item: newItem.item,
            other_name: newItem.other_name,
            item_name: newItem.item_name || newItem.type || newItem.item, // Add this
            item_name_tamil: newItem.item_name_tamil || "", // Add this
            category: newItem.category,
            type: newItem.type,
            quantity: parseFloat(newItem.quantity),
            weight: parseFloat(newItem.weight),
            purity: parseFloat(newItem.purity),
            pure: parseFloat(newItem.pure),
            total_amount: parseFloat(newItem.total_amount),
            adjustment: parseFloat(newItem.adjustment || 0),
          }
        : i,
    );
    setUpdateData((prev) => ({ ...prev, items }));
    resetNewItem();
  };

  const validateForm = () => {
    if (updateData.items.length === 0)
      return (toast.error("Add at least one item", 3000, "topRight"), false);
    if (!updateData.return_type)
      return (toast.error("Select return type", 3000, "topRight"), false);
    if (
      updateData.return_type === "Pure" &&
      (!updateData.pure || parseFloat(updateData.pure) <= 0)
    )
      return (toast.error("Enter valid pure return", 3000, "topRight"), false);
    if (
      updateData.return_type === "Amount" &&
      (!updateData.paid || parseFloat(updateData.paid) <= 0)
    )
      return (toast.error("Enter valid paid amount", 3000, "topRight"), false);
    return true;
  };

  const preparePayload = () => ({
    ...updateData,
    paid:
      updateData.return_type === "Amount"
        ? parseFloat(updateData.paid) || 0
        : 0,
    // "pure" carries the grams being returned for BOTH return types (typed
    // directly in Pure mode, converted from paid/rate in Amount mode) and
    // must match updateData.close, which is computed from it the same way.
    pure:
      updateData.return_type === "Pure" || updateData.return_type === "Amount"
        ? parseFloat(updateData.pure) || 0
        : 0,
    enter_amount: parseFloat(updateData.enter_amount) || 0,
    items: updateData.items.map((i) => ({
      ...i,
      percentage: i.purity,
      adjustment: parseFloat(i.adjustment || 0),
    })),
  });

  const handleUpdate = async () => {
    if (!validateForm()) return;
    setLoading(true);
    try {
      await axios.put(
        `${ApiUrl}/Api/purchase_details.php/${id}`,
        preparePayload(),
      );
      toast.success("Purchase updated!", 3000, "topRight");
      navigate("/purchases");
    } catch (err) {
      toast.error("Update failed", 3000, "topRight");
    } finally {
      setLoading(false);
    }
  };

  const handlePrint = async () => {
    if (!validateForm()) return;
    setLoading(true);
    try {
      await axios.put(
        `${ApiUrl}/Api/purchase_details.php/${id}`,
        preparePayload(),
      );
      toast.success("Ready to print!", 3000, "topRight");
      setShowModal(true);
    } catch (err) {
      toast.error("Print failed", 3000, "topRight");
    } finally {
      setLoading(false);
    }
  };

  const handleClear = () => {
    resetNewItem();
    clearSupplier();
  };

  const closeModal = () => {
    setShowModal(false);
    navigate(`/purchase-bill/${updateData.purchase_id}`);
  };

  return (
    <>
      {loading && (
        <div className="loading-overlay">
          <div className="loading-message">
            <div className="loadinggif"></div>
          </div>
        </div>
      )}
      <div className="container-fluid py-2">
        {/* Header - unchanged */}
        <div className="row">
          <div className="col-lg-3">
            <div className="card p-2">
              <div className="row">
                <div className="col-md-6">
                  <label className="form-label">Purchase ID</label>
                  <input
                    type="text"
                    className="form-control"
                    value={updateData.purchase_id}
                    readOnly
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={updateData.purchase_date}
                    onChange={(e) =>
                      setUpdateData((prev) => ({
                        ...prev,
                        purchase_date: e.target.value,
                      }))
                    }
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-9">
            <div className="card p-2">
              <div className="row g-3">
                <div className="col-md-3 position-relative">
                  <label className="form-label">Supplier</label>
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search supplier..."
                      value={searchTerm}
                      disabled
                      onChange={(e) => {
                        setSearchTerm(e.target.value);
                        setShowDropdown(true);
                      }}
                      onFocus={() => setShowDropdown(true)}
                    />
                    {searchTerm && (
                      <button
                        className="btn btn-outline-secondary h-75"
                        type="button"
                        onClick={clearSupplier}
                        disabled
                      >
                        <i className="bi bi-x"></i>
                      </button>
                    )}
                  </div>
                  {showDropdown && suppliers.length > 0 && (
                    <div className="dropdown-menu show w-100">
                      {suppliers
                        .filter(
                          (s) =>
                            s.supplier_id
                              .toLowerCase()
                              .includes(searchTerm.toLowerCase()) ||
                            s.name
                              .toLowerCase()
                              .includes(searchTerm.toLowerCase()),
                        )
                        .map((s) => (
                          <button
                            key={s.supplier_id}
                            className="dropdown-item"
                            onClick={() => handleSelectSupplier(s)}
                            type="button"
                          >
                            {s.supplier_id} - {s.name}
                          </button>
                        ))}
                    </div>
                  )}
                </div>
                <div className="col-md-3">
                  <label className="form-label">Supplier Name</label>
                  <input
                    type="text"
                    className="form-control"
                    style={{ opacity: 0.6, backgroundColor: "#f0f0f0" }}
                    value={
                      updateData.supplier_details?.name ||
                      selectedSupplier?.name ||
                      ""
                    }
                    disabled
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label">Mobile</label>
                  <input
                    type="text"
                    className="form-control"
                    style={{ opacity: 0.6, backgroundColor: "#f0f0f0" }}
                    value={
                      updateData.supplier_details?.mobile ||
                      selectedSupplier?.mobile ||
                      ""
                    }
                    disabled
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label">Address</label>
                  <input
                    type="text"
                    className="form-control"
                    style={{ opacity: 0.6, backgroundColor: "#f0f0f0" }}
                    value={
                      updateData.supplier_details?.address ||
                      selectedSupplier?.address ||
                      ""
                    }
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Item Entry Form - ADJUSTMENT ADDED */}
        <div className="card p-2 mt-1">
          <div className="row g-3">
            <div className="col-md-2">
              <label className="form-label">Item</label>
              <select
                className="form-select"
                value={newItem.item}
                onChange={(e) =>
                  setNewItem({
                    ...newItem,
                    item: e.target.value,
                    type: e.target.value === "Bar" ? "" : newItem.type,
                  })
                }
              >
                <option value="">Select Item</option>
                <option value="Bar">Bar</option>
                <option value="Jewels">Jewels</option>
                <option value="Others">Others</option>
              </select>
            </div>

            {newItem.item === "Others" && (
              <div className="col-md-2">
                <label className="form-label">Others Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={newItem.other_name}
                  onChange={(e) =>
                    setNewItem({ ...newItem, other_name: e.target.value })
                  }
                />
              </div>
            )}

            <div className="col-md-2">
  <label className="form-label">Category</label>
  <select 
    className="form-select" 
    value={newItem.category} 
    onChange={(e) => {
      setNewItem({ 
        ...newItem, 
        category: e.target.value,
        item_name: "", // Reset item name
        item_name_tamil: ""
      });
    }}
  >
    <option value="">Select Category</option>
    <option value="Gold">Gold</option>
    <option value="Silver">Silver</option>
    <option value="Gold Coin">Gold Coin</option>
    <option value="Silver Coin">Silver Coin</option>
  </select>
</div>

         {/* Item Name dropdown - shows only items matching selected category */}
<div className="col-md-2">
  <label className="form-label">Item Name</label>
  <select
    className="form-select"
    value={newItem.item_name || ""}
    onChange={(e) => {
      const selectedValue = e.target.value;
      const selected = filteredProducts.find(p => 
        (p.item_name_english || p.item_name) === selectedValue
      );
      setNewItem({
        ...newItem,
        item_name: selectedValue,
        item_name_tamil: selected?.item_name_tamil || "",
      });
    }}
    disabled={!newItem.category}
  >
    <option value="">Select Item Name</option>
    {filteredProducts.map((product) => {
      const displayName = product.item_name_tamil 
        ? `${product.item_name_english || product.item_name} / ${product.item_name_tamil}`
        : (product.item_name_english || product.item_name);
      return (
        <option key={product.id} value={product.item_name_english || product.item_name}>
          {displayName}
        </option>
      );
    })}
  </select>
  {!newItem.category && (
    <small className="text-muted">Please select category first</small>
  )}
</div>

            {/* <div className="col-md-1">
              <label className="form-label">Qty</label>
              <input
                type="text"
                className="form-control"
                value={newItem.quantity}
                onChange={(e) => /^\d*$/.test(e.target.value) && setNewItem({ ...newItem, quantity: e.target.value })}
              />
            </div> */}

            <div className="col-md-1">
              <label className="form-label">Weight (g)</label>
              <input
                type="text"
                className="form-control"
                value={newItem.weight}
                onChange={(e) =>
                  /^\d*\.?\d*$/.test(e.target.value) &&
                  setNewItem({ ...newItem, weight: e.target.value })
                }
              />
            </div>

            {/* ADJUSTMENT COLUMN */}
            <div className="col-md-2 position-relative">
              <label>Adjustment</label>
              <div className="input-group mt-2">
                <button
                  className="btn btn-outline-danger btn-sm"
                  type="button"
                  style={{ height: "30px" }}
                  onClick={() => {
                    const v = parseFloat(adjustmentInput) || 0;
                    if (v > 0) {
                      setNewItem((p) => ({
                        ...p,
                        adjustment: (parseFloat(p.adjustment || 0) - v).toFixed(
                          3,
                        ),
                      }));
                      setAdjustmentInput("");
                    }
                  }}
                >
                  <i className="fa-solid fa-minus"></i>
                </button>

                <input
                  type="text"
                  className="form-control form-control-sm text-center"
                  value={adjustmentInput}
                  placeholder="0.000"
                  onChange={(e) => {
                    if (/^\d*\.?\d*$/.test(e.target.value))
                      setAdjustmentInput(e.target.value);
                  }}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      const v = parseFloat(adjustmentInput) || 0;
                      if (v > 0) {
                        setNewItem((p) => ({
                          ...p,
                          adjustment: (
                            parseFloat(p.adjustment || 0) + v
                          ).toFixed(3),
                        }));
                        setAdjustmentInput("");
                      }
                    }
                  }}
                />

                <button
                  className="btn btn-outline-success btn-sm"
                  type="button"
                  style={{ height: "30px" }}
                  onClick={() => {
                    const v = parseFloat(adjustmentInput) || 0;
                    if (v > 0) {
                      setNewItem((p) => ({
                        ...p,
                        adjustment: (parseFloat(p.adjustment || 0) + v).toFixed(
                          3,
                        ),
                      }));
                      setAdjustmentInput("");
                    }
                  }}
                >
                  <i className="fa-solid fa-plus"></i>
                </button>

                {parseFloat(newItem.adjustment || 0) !== 0 && (
                  <button
                    className="btn btn-sm translate-middle-y me-1"
                    style={{
                      zIndex: 10,
                      background: "none",
                      border: "none",
                      position: "relative",
                      top: "10px",
                      right: "50px",
                    }}
                    onClick={() =>
                      setNewItem((p) => ({ ...p, adjustment: "0.000" }))
                    }
                  >
                    <i className="fa-solid fa-xmark text-danger"></i>
                  </button>
                )}
              </div>
              {/* <small className="text-muted d-block text-center mt-1">
                Current: {parseFloat(newItem.adjustment || 0).toFixed(3)}g
              </small> */}
            </div>

            <div className="col-md-1">
              <label className="form-label">Purity (%)</label>
              <input
                type="text"
                className="form-control"
                value={newItem.purity}
                disabled={newItem.item === "Bar"}
                onChange={(e) => {
                  const val = e.target.value;
                  if (/^\d{0,3}(\.\d{0,2})?$/.test(val)) {
                    const num = parseFloat(val);
                    if (val === "" || num <= 100)
                      setNewItem({ ...newItem, purity: val });
                    else
                      toast.error(
                        "Purity cannot exceed 100%",
                        3000,
                        "topRight",
                      );
                  }
                }}
              />
            </div>

            <div className="col-md-1">
              <label className="form-label">Pure (g)</label>
              <input
                type="text"
                className="form-control"
                value={newItem.pure || "0.000"}
                readOnly
              />
            </div>

            <div className="col-md-1 mt-4">
              {editingItemId === null ? (
                <button
                  className="btn btn-success btn-sm mx-2 mt-4"
                  onClick={handleAddItem}
                >
                  <i className="bi bi-plus"></i>
                </button>
              ) : (
                <button
                  className="btn btn-info btn-sm mx-2 mt-4"
                  onClick={handleUpdateItem}
                >
                  <i className="bi bi-check"></i>
                </button>
              )}
            </div>
          </div>
        </div>

        {/* Item List - ADJUSTMENT COLUMN ADDED */}
        <div className="container-fluid p-2">
          <div className="row">
            <div className="col-lg-9">
              <div className="card card-body p-2">
                <h6>Item List</h6>
                <div className="p-2" style={{ backgroundColor: "#E8F0FA" }}>
                  <div className="table-container">
                    <table className="table table-layout-fixed w-100">
                      <thead className="bg-light">
                        <tr>
                          <th>S.No</th>
                          <th>Item</th> {/* Bar/Jewels/Others */}
                          <th>Item Name</th> {/* From product_type dropdown */}
                          <th>Category</th> {/* Gold/Silver */}
                          <th>Weight(g)</th>
                          <th>Purity (%)</th>
                          <th>Pure(g)</th>
                          <th>Adjustment</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {updateData.items.length > 0 ? (
                          updateData.items.map((item, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>
                                {item.item}
                                {item.other_name ? ` (${item.other_name})` : ""}
                              </td>
                              <td>
                                {item.item_name_tamil
                                  ? `${item.item_name_english || item.item_name || item.item} / ${item.item_name_tamil}`
                                  : item.item_name_english ||
                                    item.item_name ||
                                    item.item}
                              </td>
                              <td>{item.category}</td>
                              <td>{parseFloat(item.weight).toFixed(3)}g</td>
                              <td>{parseFloat(item.purity).toFixed(2)}%</td>
                              <td>{parseFloat(item.pure).toFixed(3)}g</td>
                              <td className="text-end">
                                <span
                                  className={`fw-bold ${parseFloat(item.adjustment) > 0 ? "text-success" : parseFloat(item.adjustment) < 0 ? "text-danger" : "text-muted"}`}
                                >
                                  {parseFloat(item.adjustment) > 0 ? "+" : ""}
                                  {parseFloat(item.adjustment || 0).toFixed(3)}g
                                </span>
                              </td>
                              <td>
                                <button
                                  className="btn btn-sm btn-light me-1"
                                  onClick={() => handleEditItem(item.id)}
                                >
                                  <i className="fa-solid fa-pen-to-square text-primary fs-6"></i>
                                </button>
                                <button
                                  className="btn btn-sm btn-light me-1"
                                  onClick={() => handleRemoveItem(item.id)}
                                >
                                  <i className="fa-solid fa-trash text-danger fs-6"></i>
                                </button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="9" className="text-center">
                              No items added yet
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
               {/* Supplier Payment History */}
        {selectedSupplier?.supplier_id && (
          // <div className="container-fluid p-2">
            <div className="card card-body p-2 mt-2">
              <h6>
                Payment History - {selectedSupplier.name} (
                {selectedSupplier.supplier_id}) on {updateData.purchase_date}
              </h6>
              <div className="p-2" style={{ backgroundColor: "#E8F0FA" }}>
                <div className="table-container">
                  <table className="table table-layout-fixed w-100">
                    <thead className="bg-light">
                      <tr>
                        <th>Date</th>
                        <th>Total (g)</th>
                        <th>Paid</th>
                        <th>Balance (g)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loadingPaymentHistory ? (
                        <tr>
                          <td colSpan="4" className="text-center">
                            Loading...
                          </td>
                        </tr>
                      ) : supplierPaymentHistory.length > 0 ? (
                        supplierPaymentHistory.map((record) => (
                          <tr key={record.id || record.purchase_id}>
                            <td>{record.purchase_date}</td>
                            <td>
                              {parseFloat(record.total_pure || 0).toFixed(3)}g
                            </td>
                            <td>
                              {record.return_type === "Amount"
                                ? `₹${parseFloat(record.paid || 0).toFixed(2)}`
                                : record.return_type === "Pure"
                                  ? `${parseFloat(record.pure || 0).toFixed(3)}g`
                                  : "-"}
                            </td>
                            <td>
                              {parseFloat(record.close || 0).toFixed(3)}g
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="4" className="text-center">
                            No other payment history for this supplier on this date
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          // </div>
        )}
            </div>

            {/* Summary Section */}
            <div className="col-lg-3">
              <div className="card p-3">
                <div className="row mb-3">
                  <div className="col-md-6">
                    <label className="form-label">Total Pure (g)</label>
                  </div>
                  <div className="col-md-6">
                    <input
                      type="text"
                      className="form-control"
                      value={updateData.total_pure || "0.000"}
                      readOnly
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <label className="form-label">Return Type</label>
                  </div>
                  <div className="col-md-6">
                    <select
                      className="form-select"
                      value={updateData.return_type}
                      onChange={(e) => {
                        const newReturnType = e.target.value;
                        // DON'T reset opening when changing return type
                        setUpdateData((prev) => ({
                          ...prev,
                          return_type: newReturnType,
                          paid: "",
                          pure: "",
                          enter_amount: "",
                          // Keep opening, current, close as they are
                        }));
                        setReturnPureCalculated("0.000");
                      }}
                    >
                      <option value="">Select Type</option>
                      <option value="Pure">Pure</option>
                      <option value="Amount">Amount</option>
                    </select>
                  </div>
                </div>

                {updateData.return_type === "Pure" && (
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label className="form-label">Pure (g)</label>
                    </div>
                    <div className="col-md-6">
                      <input
                        type="text"
                        className="form-control"
                        value={updateData.pure || ""}
                        onChange={(e) => {
                          if (/^\d*\.?\d*$/.test(e.target.value))
                            setUpdateData({
                              ...updateData,
                              pure: e.target.value,
                            });
                        }}
                      />
                    </div>
                  </div>
                )}

                {updateData.return_type === "Amount" && (
                  <>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <label className="form-label">Enter Amount (₹)</label>
                      </div>
                      <div className="col-md-6">
                        <input
                          type="text"
                          className="form-control"
                          value={updateData.enter_amount || ""}
                          readOnly
                        />
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <label className="form-label">Paid (₹)</label>
                      </div>
                      <div className="col-md-6">
                        <input
                          type="text"
                          className="form-control"
                          value={updateData.paid || ""}
                          onChange={(e) => {
                            const val = e.target.value;
                            if (!/^\d*\.?\d*$/.test(val)) return;

                            const paidNum = parseFloat(val) || 0;
                            const hasGold = updateData.items.some(
                              (i) => (i.category === "Gold" || i.category === "Gold Coin"),
                            );
                            const hasSilver = updateData.items.some(
                              (i) => (i.category === "Silver" || i.category === "Silver Coin"),
                            );
                            const rate =
                              hasGold && !hasSilver
                                ? todayRates.gold_pure_rate
                                : hasSilver && !hasGold
                                  ? todayRates.silver_pure_rate
                                  : 0;
                            const grams = rate > 0 ? paidNum / rate : 0;

                            setUpdateData({
                              ...updateData,
                              paid: val,
                              pure: grams.toFixed(3),
                            });
                            setReturnPureCalculated(grams.toFixed(3));
                          }}
                        />
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <label className="form-label text-primary fw-bold">
                          Return Pure (g)
                        </label>
                      </div>
                      <div className="col-md-6">
                        <input
                          type="text"
                          className="form-control bg-light"
                          value={updateData.pure || "0.000"}
                          readOnly
                        />
                      </div>
                    </div>
                  </>
                )}

                <div className="row mb-3">
                  <div className="col-md-6">
                    <label className="form-label">Opening</label>
                  </div>
                  <div className="col-md-6">
                    <input
                      type="text"
                      className="form-control"
                      value={updateData.opening || "0.000"}
                      readOnly
                      style={{ opacity: 0.6, backgroundColor: "#f0f0f0" }}
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-6">
                    <label className="form-label">Current</label>
                  </div>
                  <div className="col-md-6">
                    <input
                      type="text"
                      className="form-control"
                      value={updateData.current || "0.000"}
                      readOnly
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-6">
                    <label className="form-label">Closing</label>
                  </div>
                  <div className="col-md-6">
                    <input
                      type="text"
                      className="form-control"
                      value={updateData.close || "0.000"}
                      readOnly
                    />
                  </div>
                </div>

                <div className="d-flex justify-content-between mt-2">
                  <button
                    className="btn btn-secondary btn-sm"
                    onClick={() => navigate("/purchases")}
                  >
                    <i className="fa-solid fa-arrow-left"></i> Back
                  </button>
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={handleClear}
                  >
                    <i className="bi bi-x-circle"></i> Clear
                  </button>
                  <button
                    className="btn btn-primary btn-sm"
                    onClick={handlePrint}
                    disabled={loading}
                  >
                    <i className="bi bi-printer"></i> Print
                  </button>
                  <button
                    className="btn btn-success btn-sm"
                    onClick={handleUpdate}
                    disabled={loading}
                  >
                    <i className="bi bi-save"></i> Update
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Print Modal */}
        <div
          className={`modal fade ${showModal ? "show" : ""}`}
          style={{ display: showModal ? "block" : "none" }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h6 className="modal-title text-primary">Print Confirmation</h6>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body text-center">
                <p>Do you want to print the purchase bill?</p>
                <div className="d-flex justify-content-center mt-4">
                  <button
                    type="button"
                    className="btn btn-secondary btn-sm mx-2"
                    onClick={() => navigate("/purchases")}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary btn-sm"
                    onClick={closeModal}
                    disabled={loading}
                  >
                    {loading ? "Processing..." : "Print"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {showModal && <div className="modal-backdrop fade show"></div>}
      </div>
    </>
  );
}

export default UpdatePurchase;